import React, { useCallback, useEffect, useMemo, useState } from "react";
import "../RegisterWolfScreen/Register.css";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Badge, Button, Col, Radio, Row, Select } from "antd";
import {
  PlusCircleOutlined,
  DeleteOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import {
  Controller,
  useFieldArray,
  useForm,
  BatchFieldArrayUpdate,
} from "react-hook-form";
import ConfirmModal from "./ConfirmModal";
import {
  AuthorizedDirector,
  BlacklistItem,
  DirectorList,
  Errors,
  ErrosFIleUpload,
  Files,
  FIleUpload,
  FormRegister,
  initailErrors,
  initialAuthorizedDirector,
  initialDirector,
  initialFileUpload,
  initialServiceAndItem,
  ResponseDataBalckList,
  ServiceAndItem,
} from "./RegisterModel";
import {
  CheckBlackListForm,
  GetAllAddress,
  GetDistriceById,
  GetProvinceById,
  GetStateById,
  SaveUserToDatabase,
} from "../../Services/e-pro/RegisterService";
import {
  Districes,
  Provinces,
  States,
} from "../../Services/e-pro/models/RegisterModel";
import {
  GetAllBlackList,
  GetAllCharaterics,
  GetAllExecutivePosition,
  GetAllServiceAndItem,
  GetAllTitleName,
} from "../../Services/e-pro/CatalogMasterDataService";
import LegalEntiryBlackListModal from "./LegalEntiryBlackListModal";
import { Compare } from "../../Helper/stringCompare";
import { UploadFileAttachFiles, UploadFileAttachFiles_v2 } from "../../Services/AttachFileService";
import { generateQuickGuid } from "../../Helper/GenerateGuid";
import Cancel from "../../assets/ImageAddControl/cancel.svg";
import Swal from "sweetalert2";
import {
  OpenApiMemorandumSeller,
  OpenApiRegister,
} from "../../Services/e-pro/OpenApiEproService";
import { MasterData } from "../../Services/e-pro/models/MasterDataModel";
import { OptionList } from "../../Services/e-pro/models/ServiceAndItemModel";
import dayjs from "dayjs";
import moment from "moment";
moment.locale('th')
import { DataAndPermission } from "../ScreenGeneral/SupplierListDetail";
import { useSessionContext } from "../../Context/AuthContext";
import { useUserContext } from "../../Context/UserContext";
import { SupplierDetail } from "../../Services/e-pro/models/SupplierModel";
import { CheckRolePermission } from "../../Services/AuthorizedService";
import OTPModal from "../LoginScreen/OTPModal";
import { requestOTPAndSaveToDb } from "../../Services/e-pro/SupplierService";
import locale from 'antd/es/date-picker/locale/th_TH';
import DatePicker from "../../Helper/DatePicker";
type Props = {
  sellerDetail?: SupplierDetail;
};
const RegisterLegalEntityScreen = ({ sellerDetail }: Props) => {
  const [showDailogConfirm, setShowDailogConfirm] = useState<boolean>(false);
  const [fileList, setFileList] = useState<FIleUpload>(initialFileUpload);
  const [showFiles, setshowFiles] = useState<FIleUpload>(initialFileUpload);
  const [errosSize, setErrosSize] = useState<ErrosFIleUpload>(initailErrors);
  const [showModalOtp, setShowModalOtp] = useState<boolean>(false);
  const [showOtherInput, setShowOtherInput] = useState<boolean[]>([false, false, false]);
  const [dataOTP, setDataOTP] = useState<any>();
  const dataOTPToSet = useMemo(() => dataOTP, [dataOTP]);
  const [provinces, setProvinces] = useState<Provinces[]>();
  const [distrinces, setDistrinces] = useState<Districes[]>();
  const [states, setStates] = useState<States[]>();
  const [post, setPost] = useState<number>();
  const [blackList, setBlackList] = useState<BlackListData[]>([]);
  const [showDailogBlackList, setShowDailogBlackList] =
    useState<boolean>(false);
  const [nameDirector, setNameDirector] = useState<
    ResponseDataBalckList | undefined
  >(undefined);
  const [formModel, setFormModel] = useState<any | undefined>(undefined);
  const history = useHistory();
  const [excutivePosition, setExcutivePosition] = useState<MasterData[]>();
  const [characteristics, setCharacteristics] = useState<MasterData[]>();
  const [titleName, setTitleName] = useState<MasterData[]>();
  const [category, setCategory] = useState<string[]>();
  const [item, setItem] = useState<OptionList[]>();
  const [isAdmin, serIsAdmin] = React.useState(false);
  const [confirmOTP, setConfirmOTP] = useState();
  const [sessionContext] = useSessionContext();
  const [userData] = useUserContext();
  const {
    control,
    register,
    handleSubmit,
    clearErrors,
    setError,
    getValues,
    watch,
    unregister,
    formState: { errors },
    setValue,
  } = useForm<FormRegister>({
    defaultValues: {
      ListOfDirector: initialDirector,
      ListAuthorizedDirectors: initialAuthorizedDirector,
      ServiceAndItem: initialServiceAndItem,
    },
  });

  const datePickerTh = {
    ...locale,
    lang: {
      ...locale.lang,
      yearFormat: 'BBBB',
      dateFormat: 'M/D/BBBB',
      dateTimeFormat: 'M/D/BBBB HH:mm:ss',
    },
    dateFormat: 'BBBB-MM-DD',
    dateTimeFormat: 'BBBB-MM-DD HH:mm:ss',
    weekFormat: 'BBBB-wo',
    monthFormat: 'BBBB-MM',
  };
  const getRolePermission = async () => {
    const employeeId = localStorage.getItem("employeeId") ?? null;
    if (employeeId) {
      const isAdmin = await CheckRolePermission(Number(employeeId));
      serIsAdmin(isAdmin);
    }
  };

  const fetchData = async () => {
    const response = await GetAllAddress();
    const blackList = await GetAllBlackList();
    const position = await GetAllExecutivePosition();
    const character = await GetAllCharaterics();
    const title = await GetAllTitleName();
    const serviceAndItem = await GetAllServiceAndItem();
    setBlackList(blackList.data);
    setProvinces(response.Data);
    setExcutivePosition(position.data);
    setCharacteristics(character.data);
    setTitleName(title.data);
    setCategory(serviceAndItem.data.category);
    setItem(serviceAndItem.data.options);
  };

  useEffect(() => {
    fetchData();
    getRolePermission();
  }, []);

  const permissionData: DataAndPermission = {
    isAuthenticated: sessionContext?.isAuthenticated,
    isAdmin: isAdmin,
    isSeller: userData?.EmployeeCode?.toUpperCase().startsWith("SELL"),
  };

  const {
    fields: fieldsDir,
    remove: removeDir,
    append: appendDir,
  } = useFieldArray({
    control,
    name: "ListOfDirector",
  });

  const {
    fields: fieldsAtrDirector,
    remove: removeAtrDirector,
    append: appendAtrDirector,
  } = useFieldArray({
    control,
    name: "ListAuthorizedDirectors",
  });

  const {
    fields: serviceField,
    remove: removeService,
    append: appenService,
    replace: replaceService,
  } = useFieldArray({ control, name: "ServiceAndItem" });

  useEffect(() => {
    if (sellerDetail && permissionData.isAuthenticated) {
      setValue("SellerNameEn", sellerDetail?.SellerName);
      setValue("SellerNameTh", sellerDetail?.SellerName);
      setValue("SellerRegisterType", sellerDetail?.SellerRegisterType);
      setValue("SellerStatus", sellerDetail?.SellerStatus);
      setValue("IdentificationNo", sellerDetail?.IdentificationNo);
      setValue("MobilePhone", sellerDetail.MobilePhone);
      setValue("NumberOfShares", sellerDetail?.NumberOfShared);
      setValue("DateOfRegisteration", sellerDetail?.DateOfRegisteration);
      setValue("RegisteredCapital", sellerDetail?.RegisteraedCapital);
      setValue("BussniesType", sellerDetail?.BussniesType);
      setValue(
        "TaxpayerIdentificationNo",
        sellerDetail?.TaxpayerIdentificationNo
      );
      setValue("Region", sellerDetail?.Region);
      setValue("Buildings", sellerDetail?.Building);
      setValue("Room", sellerDetail?.Room);
      setValue("Floor", sellerDetail?.Floor);
      setValue("Village", sellerDetail?.Village);
      setValue("HouseNo", sellerDetail?.HouseNo);
      setValue("Swine", sellerDetail?.Swine);
      setValue("Alley", sellerDetail?.Alley);
      setValue("Road", sellerDetail?.Road);
      setValue("Province", sellerDetail?.Province);
      setValue("State", sellerDetail?.State);
      setValue("Districe", sellerDetail?.Districe);
      setValue("Post", sellerDetail?.Post);
      setValue("ContactName", sellerDetail?.ContactName);
      if (sellerDetail?.PhoneNumber != null) {
        const splitePhoneNumber = sellerDetail?.PhoneNumber?.split(" ");
        if (splitePhoneNumber[0]) setValue("PhoneNumber", splitePhoneNumber[0]);
        if (splitePhoneNumber[2]) setValue("Per", splitePhoneNumber[2]);
      }
      setValue("Email", sellerDetail?.Email);
      setValue("DigitalContact", sellerDetail?.DigitalContact);
      setValue("OtherService", sellerDetail?.OtherService);
      setValue(`deliveryDate.capital`, sellerDetail.SendDateBkkArea);
      setValue(`deliveryDate.provincial`, sellerDetail.SendDateOtherArea);

      if (
        sellerDetail?.CertificateOfRegisteration != null &&
        sellerDetail?.CertificateOfRegisteration.length > 0
      ) {
        setValue(
          `CertificateOfRegisteration`,
          sellerDetail?.CertificateOfRegisteration
        );
        showFileList({
          CertificateOfRegisteration:
            sellerDetail?.CertificateOfRegisteration?.map((item) => {
              return { name: item, file: undefined };
            }),
        });
      }
      if (
        sellerDetail?.CertOfCompletion != null &&
        sellerDetail?.CertOfCompletion.length > 0
      ) {
        setValue(`CertOfCompletion`, sellerDetail?.CertOfCompletion);
        showFileList({
          CertOfCompletion: sellerDetail?.CertOfCompletion.map((item) => {
            return { name: item, file: undefined };
          }),
        });
      }
      if (
        sellerDetail?.Certificate != null &&
        sellerDetail?.Certificate.length > 0
      ) {
        setValue(`Certificate`, sellerDetail?.Certificate);
        showFileList({
          Certificate: sellerDetail?.Certificate.map((item) => {
            return { name: item, file: undefined };
          }),
        });
      }
      if (
        sellerDetail?.ExceptionDetail != null &&
        sellerDetail?.ExceptionDetail.length > 0
      ) {
        setValue(`ExceptionDetail`, sellerDetail?.ExceptionDetail);
        showFileList({
          ExceptionDetail: sellerDetail?.ExceptionDetail.map((item) => {
            return { name: item, file: undefined };
          }),
        });
      }

      if (sellerDetail?.LogoPath != null) {
        setValue(`LogoPath.${0}`, sellerDetail?.LogoPath);
        showFileList({
          LogoPath: [{ name: sellerDetail.LogoPath, file: undefined }],
        });
      }
      if (sellerDetail?.CatalogFilePath != null) {
        setValue(`CatalogFilePath.${0}`, sellerDetail?.CatalogFilePath);
        showFileList({
          CatalogFilePath: [
            { name: sellerDetail.CatalogFilePath, file: undefined },
          ],
        });
      }
      if (
        sellerDetail?.DirectorLists != null &&
        sellerDetail?.DirectorLists.length > 0
      ) {
        removeDir(0);
        sellerDetail?.DirectorLists?.forEach((item) => {
          appendDir(item);
        });
      }

      if (
        sellerDetail?.AuthorizedDirectors != null &&
        sellerDetail?.AuthorizedDirectors.length > 0
      ) {
        removeAtrDirector(0);
        sellerDetail?.AuthorizedDirectors.forEach((item) => {
          appendAtrDirector(item);
        });
      }
      if (
        sellerDetail?.ServiceAndItem != null &&
        sellerDetail?.ServiceAndItem.length > 0
      ) {
        replaceService(
          sellerDetail.ServiceAndItem.map((item) => ({
            ServiceItemType: item.ServiceType,
            ServiceItemName: item.ServiceItemName,
            OtherService: item.OtherService,
          }))
        );
      }
    }
  }, [sellerDetail, permissionData.isAuthenticated, setValue]);

  // console.log("blackList = ", blackList);

  const watchProvince = watch("Province");
  const getProvince = async () => {
    const value = watch("Province");
    const response = await GetProvinceById(value);
    if (response) {
      setDistrinces(response.Districes);
    }
  };
  useEffect(() => {
    getProvince();
  }, [watchProvince]);

  const watchDistrice = watch("Districe");
  const getDistrice = async () => {
    const value = watch("Districe");
    const response = await GetDistriceById(value);
    if (response) {
      setStates(response.States);
    }
  };
  useEffect(() => {
    getDistrice();
  }, [watchDistrice]);

  const watchState = watch("State");
  const getState = async () => {
    const value = watch("State");
    const response = await GetStateById(value);
    if (response) {
      setPost(response.Post);
      setValue("Post", JSON.stringify(response.Post));
    }
  };
  useEffect(() => {
    getState();
  }, [watchState]);

  useEffect(() => {
    if (watch("SellerStatus") !== "AVL-C") {
      clearErrors("deliveryDate.capital");
      clearErrors("deliveryDate.provincial");
    }
  }, [watch("SellerStatus")]);

  useEffect(() => {
    const items = watch("ServiceAndItem");
    const hasValidItem = items?.some((item) => {
      if (!item.ServiceItemType) return false;
      // "โปรดระบุ" เป็น sentinel value จาก API ที่มีความหมายเดียวกับ "อื่นๆ"
      const isOtherMode = item.ServiceItemType === "อื่นๆ" || item.ServiceItemName === "อื่นๆ" || item.ServiceItemName === "โปรดระบุ";
      if (isOtherMode) return !!item.OtherService?.trim();
      return !!item.ServiceItemName;
    });

    if (hasValidItem) {
      clearErrors("ServiceAndItem");
    }
  }, [watch("ServiceAndItem")]);

  // console.log("ListAuthorizedDirectors", watch("ListAuthorizedDirectors"));

  const mapFormToValues = async (formModel: any) => {
    let mapFormToValue: { [name: string]: string } = {
      ชื่อนิติบุคคล: "SellerNameTh",
      "ชื่อนิติบุคคล (ภาษาอังกฤษ)": "SellerNameEn",
      ประเภทนิติบุคคล: "SellerRegisterType",
      เลขทะเบียนนิติบุคคล: "IdentificationNo",
      "หมายเลขโทรศัพท์ (สำหรับยืนยันตัวตน)": "MobilePhone",
      วันเดือนปีที่จดทะเบียน: "DateOfRegisteration",
      จำนวนหุ้น: "NumberOfShares",
      เงินทุนจดทะเบียน: "RegisteredCapital",
      รายชื่อกรรมการ: "ListOfDirector",
      รายชื่อกรรมการผู้มีอำนาจผูกพันนิติบุคคล: "ListAuthorizedDirectors",
      ประเภทกิจการ: "BussniesType",
      เลขประจำตัวผู้เสียภาษีอากร: "TaxpayerIdentificationNo",
      ที่ตั้งสำนักงานใหญ่: "Region",
      ชื่ออาคาร: "Buildings",
      ห้องเลขที่: "Room",
      ชั้นที่: "Floor",
      ชื่อหมู่บ้าน: "Village",
      เลขที่: "HouseNo",
      หมู่ที่: "Swine",
      "ตรอก/ซอย": "Alley",
      ถนน: "Road",
      จังหวัด: "Province",
      // "อำเภอ/เขต": "State",
      // "ตำบล/แขวง": "Districe",
        "อำเภอ/เขต": "Districe",
      "ตำบล/แขวง": "State",
      รหัสไปรษณีย์: "Post",
      ชื่อผู้ติดต่อ: "ContactName",
      หมายเลขโทรศัพท์: "PhoneNumber",
      "E-mail": "Email",
      "ช่องทางการประชาสัมพันธ์ (Website ,Facebook,อื่นๆ)": "DigitalContact",
      หนังสือรับรองการจดทะเบียนนิติบุคคล: "CertificateOfRegisteration",
      "ใบรับรอง เช่น Regulation Certified, Certificate, Document, ISO":
        "Certificate",
      หนังสือรับรองผลงาน: "CertOfCompletion",
      "ประวัติการได้รับข้อยกเว้น (ทางกฎหมาย หรือ เอกสิทธิ์พิเศษทางกฎหมาย หรือ ประวัติการติดบัญชีรายชื่อผู้ทิ้งงาน)":
        "ExceptionDetail",
      รูปโลโก้: "LogoPath",
      "ประเภทสินค้า/บริการ": "ServiceAndItem",
      "แนบไฟล์ Catalog แนบไฟล์ ": "CatalogFilePath",
      ปรับสถานะผู้ค้า: "SellerStatus",
      Mode: "Mode",
      SellerCode: "SellerCode",
      กรุงเทพและปริมณฑล: "Capital",
      ต่างจังหวัด: "Provincial",
    };
    let resultOpenApi = await OpenApiRegister("RC-นิติบุคคล");
    console.log("resultOpenAPi1 = ", resultOpenApi);
    resultOpenApi.subject = `${resultOpenApi.subject} ${formModel.SellerNameTh || formModel.SellerNameEn
      }`;

    resultOpenApi.userPrincipalName = sessionContext.isAuthenticated
      ? userData?.Email
      : undefined;

    resultOpenApi.form = resultOpenApi.form.map((item) => {
      let value = mapFormToValue[item.template.label];
      if (
        value != null &&
        (value == "CertificateOfRegisteration" ||
          value == "Certificate" ||
          value == "CertOfCompletion" ||
          value == "ExceptionDetail" ||
          value == "CatalogFilePath")
      ) {
        item.data.row = formModel[value]?.map((data: any) => {
          let newRow = [{ value: data.Path }];
          return newRow;
        });
      } else if (value != null && value == "LogoPath") {
        item.data.value =
          formModel["LogoPath"] != null && formModel["LogoPath"].length > 0
            ? formModel["LogoPath"][0].Path
            : "";
      } else if (
        value != null &&
        (value == "ListOfDirector" || value == "ListAuthorizedDirectors" || value == "ServiceAndItem")
      ) {
        item.data.value = "";
      } else if (value != null && typeof formModel[value] == "number") {
        item.data.value = `${formModel[value]}`;
      } else {
        item.data.value = formModel[value];
      }

      if (item.template.label == "รายชื่อกรรมการ") {
        let columnNames: (keyof DirectorList)[] = [
          "DirectorTitle",
          "DirectorFullName",
          "DirectorIdentification",
        ];
        item.data.row = formModel["ListOfDirector"]?.map(
          (data: DirectorList) => {
            let newRow = columnNames.map((col) => {
              return { value: data[col] };
            });
            return newRow;
          }
        );
      }
      if (item.template.label == "รายชื่อกรรมการผู้มีอำนาจผูกพันนิติบุคคล") {
        let columnNames: (keyof AuthorizedDirector)[] = [
          "AuthorTitle",
          "AuthorFullName",
          "AuthorIdentification",
          "AuthorPosition",
        ];
        item.data.row = formModel["ListAuthorizedDirectors"]?.map(
          (data: AuthorizedDirector) => {
            let newRow = columnNames.map((col) => {
              return { value: data[col] };
            });
            return newRow;
          }
        );
      }
      if (item.template.label == "ประเภทสินค้า/บริการ") {
         let columnNames: (keyof ServiceAndItem)[] = [
          "ServiceItemType",
          "ServiceItemName",
          "OtherService",
        ];
        item.data.row = formModel["ServiceAndItem"]?.map(
          (data: ServiceAndItem) => {
            let newRow = columnNames.map((col) => {
              return { value: data[col] };
            });
            return newRow;
          }
        );
        // let arrayService: string[] = [];
        // formModel["ServiceAndItem"]?.forEach((data: any) => {
        //   arrayService.push(data.ServiceItemID);
        // });
        // item.data.value = arrayService.join() ?? "";
      }
      return item;
    });
    return resultOpenApi;
  };

  const submitAndOpenForm = async (formModels: any) => {
    // Start 
    // Upload File To Server 
    // Check Permission Save 
    // Edit Or Register 
    // ------- if Edit -------
    // 
    // ------- if Register ------
    // Save Date Form Screen To DataBase
    // --if Success -- Open Memorundum 
    // --if Memorundum Success --- Alert Popup Success
    // --Else Go Remove Seller From DataBase -- Alert Popup Failed
    // --Else -- Go Remove Seller From DataBase -- Alert Popup Failed
    // End 
    const resultUpload = await upload(formModels);
    formModels.CertificateOfRegisteration =
      resultUpload.CertificateOfRegisteration.map((data: any) => {
        console.log("data for map file", data);
        return {
          FileName: data.fileName,
          Path: data.pathUrl,
        };
      });
    formModels.ExceptionDetail = resultUpload.ExceptionDetail.map(
      (data: any) => ({
        FileName: data.fileName,
        Path: data.pathUrl,
      })
    );
    formModels.Certificate = resultUpload.Certificate.map((data: any) => ({
      FileName: data.fileName,
      Path: data.pathUrl,
    }));
    formModels.CertOfCompletion = resultUpload.CertOfCompletion.map(
      (data: any) => ({
        FileName: data.fileName,
        Path: data.pathUrl,
      })
    );
    formModels.LogoPath = resultUpload.LogoPath.map((data: any) => ({
      FileName: data.fileName,
      Path: data.pathUrl,
    }));
    formModels.CatalogFilePath = resultUpload.CatalogFilePath.map(
      (data: any) => ({
        FileName: data.fileName,
        Path: data.pathUrl,
      })
    );
    const result = await mapFormToValues(formModels);
    // Case Edit Profile ด้วย User Admin หรือ Seller เป็นคน Edit เอง 
    if (permissionData?.isAuthenticated && permissionData.isAdmin || permissionData?.isAuthenticated && permissionData.isSeller) {
      const openForm = await OpenApiMemorandumSeller(result);
      if (openForm) {
        Swal.fire({
          title: "ส่งข้อมูลสำเร็จ",
          icon: "success",
          confirmButtonText: `ยืนยัน`,
          confirmButtonColor: "#6598F6",
        }).then(() => {
          if (permissionData?.isAuthenticated && permissionData.isAdmin) {
            history.push("/Supplierlist");
          } else {
            history.go(0);
          }
        });
      } else {

        Swal.fire({
          title: "ส่งข้อมูลไม่สำเร็จ",
          icon: "error",
          confirmButtonText: `ยืนยัน`,
          confirmButtonColor: "#6598F6",
        });
      }
    } else {
      // Case New Register
      formModels.CertificateOfRegisteration =
        formModels.CertificateOfRegisteration?.map((data: any) => data.Path);
      formModels.ExceptionDetail = formModels.ExceptionDetail?.map(
        (data: any) => data.Path
      );
      formModels.Certificate = formModels.Certificate?.map(
        (data: any) => data.Path
      );
      formModels.CertOfCompletion = formModels.CertOfCompletion?.map(
        (data: any) => data.Path
      );
      formModels.LogoPath =
        formModels.LogoPath != null && formModels.LogoPath.length > 0
          ? formModels.LogoPath[0].Path
          : "";
      formModels.CatalogFilePath = formModels.CatalogFilePath?.map(
        (data: any) => data.Path
      );
      // Step Save Employee ใหม่ก่อนแล้วค่อย Open Memorundum
      const resultSave = await SaveUserToDatabase(formModels, "LegalEntity");
      if (resultSave.code === "200") {
        const openForm = await OpenApiMemorandumSeller(result);
        if (openForm) {
          Swal.fire({
            title: "ส่งข้อมูลสำเร็จ",
            icon: "success",
            confirmButtonText: `ยืนยัน`,
            confirmButtonColor: "#6598F6",
          }).then(() => {
            history.push("/login");
          });
        } else {
          // Case ส่งข้อมูลไม่สำเร็จ ลบข้อมูลที่เพิ่งสร้างไป
          const resultDelete = await SaveUserToDatabase(formModels, "Delete");

          Swal.fire({
            icon: "error",
            title: resultSave.message,
            confirmButtonText: `ยืนยัน`,
            confirmButtonColor: "#6598F6",
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: resultSave.message,
          confirmButtonText: `ยืนยัน`,
          confirmButtonColor: "#6598F6",
        });
      }
    }


    //-------------------------------------------------------------
    // const resultUpload = await upload(formModels);
    // formModels.CertificateOfRegisteration =
    //   resultUpload.CertificateOfRegisteration.map((data: any) => {
    //     console.log("data for map file", data);
    //     return {
    //       FileName: data.fileName,
    //       Path: data.pathUrl,
    //     };
    //   });
    // formModels.ExceptionDetail = resultUpload.ExceptionDetail.map(
    //   (data: any) => ({
    //     FileName: data.fileName,
    //     Path: data.pathUrl,
    //   })
    // );
    // formModels.Certificate = resultUpload.Certificate.map((data: any) => ({
    //   FileName: data.fileName,
    //   Path: data.pathUrl,
    // }));
    // formModels.CertOfCompletion = resultUpload.CertOfCompletion.map(
    //   (data: any) => ({
    //     FileName: data.fileName,
    //     Path: data.pathUrl,
    //   })
    // );
    // formModels.LogoPath = resultUpload.LogoPath.map((data: any) => ({
    //   FileName: data.fileName,
    //   Path: data.pathUrl,
    // }));
    // formModels.CatalogFilePath = resultUpload.CatalogFilePath.map(
    //   (data: any) => ({
    //     FileName: data.fileName,
    //     Path: data.pathUrl,
    //   })
    // );
    // // console.log("FormModal check file = ", formModels);
    // const result = await mapFormToValues(formModels);
    // // console.log("resultOpenApi2 = ", result);
    // const openForm = await OpenApiMemorandumSeller(result);
    // if (openForm) {
    //   if (permissionData?.isAuthenticated && permissionData.isAdmin) {
    //     // Case Edit Profile ด้วย User Admin
    //     Swal.fire({
    //       title: "ส่งข้อมูลสำเร็จ",
    //       icon: "success",
    //       confirmButtonText: `ยืนยัน`,
    //       confirmButtonColor: "#6598F6",
    //     }).then(() => {
    //       history.push("/Supplierlist");
    //     });
    //   } else if (permissionData?.isAuthenticated && permissionData.isSeller) {
    //     // Case Edit Profile ด้วย User Vendor
    //     Swal.fire({
    //       title: "ส่งข้อมูลสำเร็จ",
    //       icon: "success",
    //       confirmButtonText: `ยืนยัน`,
    //       confirmButtonColor: "#6598F6",
    //     }).then(() => {
    //       history.go(0);
    //     });
    //   } else {
    //     // Case New Register
    //     formModels.CertificateOfRegisteration =
    //       formModels.CertificateOfRegisteration?.map((data: any) => data.Path);
    //     formModels.ExceptionDetail = formModels.ExceptionDetail?.map(
    //       (data: any) => data.Path
    //     );
    //     formModels.Certificate = formModels.Certificate?.map(
    //       (data: any) => data.Path
    //     );
    //     formModels.CertOfCompletion = formModels.CertOfCompletion?.map(
    //       (data: any) => data.Path
    //     );
    //     formModels.LogoPath =
    //       formModels.LogoPath != null && formModels.LogoPath.length > 0
    //         ? formModels.LogoPath[0].Path
    //         : "";
    //     formModels.CatalogFilePath = formModels.CatalogFilePath?.map(
    //       (data: any) => data.Path
    //     );
    //     const resultSave = await SaveUserToDatabase(formModels, "LegalEntity");
    //     if (resultSave.code !== "200") {
    //       Swal.fire({
    //         icon: "error",
    //         title: resultSave.message,
    //         confirmButtonText: `ยืนยัน`,
    //         confirmButtonColor: "#6598F6",
    //       });
    //     } else {
    //       Swal.fire({
    //         title: "ส่งข้อมูลสำเร็จ",
    //         icon: "success",
    //         confirmButtonText: `ยืนยัน`,
    //         confirmButtonColor: "#6598F6",
    //       }).then(() => {
    //         history.push("/login");
    //       });
    //     }
    //   }
    // } else {
    //   Swal.fire({
    //     title: "ส่งข้อมูลไม่สำเร็จ",
    //     icon: "error",
    //     confirmButtonText: `ยืนยัน`,
    //     confirmButtonColor: "#6598F6",
    //   });
    // }
  };

  //**Confirm form */
  const onsubmit = async (data: any) => {
    // console.log("data = ", data);
    Swal.fire({
      title: "กำลังส่งข้อมูล...",
      text: "กรุณารอสักครู่...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    if (data.ListAuthorizedDirectors.length > 0) {
      data.ListAuthorizedDirectors = data.ListAuthorizedDirectors.filter(
        (AuthorDirector: any) =>
          AuthorDirector.AuthorIdentification &&
          AuthorDirector.AuthorIdentification.trim() !== "" &&
          AuthorDirector.AuthorFullName &&
          AuthorDirector.AuthorFullName.trim() !== "" &&
          AuthorDirector.AuthorPosition &&
          AuthorDirector.AuthorPosition.trim() !== "" &&
          AuthorDirector.AuthorTitle &&
          AuthorDirector.AuthorTitle.trim() !== ""
      );
    }
    if (data.ListOfDirector.length > 0) {
      data.ListOfDirector = data.ListOfDirector.filter(
        (Director: any) =>
          Director.DirectorFullName &&
          Director.DirectorFullName.trim() !== "" &&
          Director.DirectorIdentification &&
          Director.DirectorIdentification.trim() !== "" &&
          Director.DirectorTitle &&
          Director.DirectorTitle.trim() !== ""
      );
    }
    if (data.ServiceAndItem && data.ServiceAndItem?.length > 0) {
      const firstItem = data.ServiceAndItem[0];
      // "อื่นๆ" และ "โปรดระบุ" อาจไม่มี ServiceItemName (ไม่มี sub-item ใน dropdown)
      // ให้ถือว่า row แรกมีข้อมูลถ้าเป็น other mode แม้ ServiceItemName จะ undefined
      const isOtherModeFirst =
        firstItem.ServiceItemType === "อื่นๆ" ||
        firstItem.ServiceItemName === "อื่นๆ" ||
        firstItem.ServiceItemName === "โปรดระบุ";
      const firstItemHasData = firstItem.ServiceItemName != undefined || isOtherModeFirst;
      if (firstItemHasData) {
        data.ServiceAndItem = data.ServiceAndItem.map((item: any) => {
          // ถ้าเป็น other mode และ ServiceItemType หรือ ServiceItemName เป็น null
          // ให้ fallback เป็น "อื่นๆ" เพื่อให้ DB รับได้
          const isOther =
            item.ServiceItemType === "อื่นๆ" ||
            item.ServiceItemName === "อื่นๆ" ||
            item.ServiceItemName === "โปรดระบุ";
          return {
            // Backend C# model (NewRegisterRequest.cs) ใช้ ServiceItemType ไม่ใช่ ServiceType
            ServiceItemType: item.ServiceItemType ?? (isOther ? "อื่นๆ" : null),
            ServiceItemName: item.ServiceItemName ?? (isOther ? "อื่นๆ" : null),
            OtherService: item.OtherService ?? null,
          };
        });
      } else {
        data.ServiceAndItem = [];
      }
    }
    try {
      let formModel: any = {
        SellerStatus:
          permissionData.isAuthenticated && sellerDetail
            ? data.SellerStatus
            : "Pending",
        SellerNameTh: data.SellerNameTh,
        SellerNameEn: data.SellerNameEn,
        SellerType: "นิติบุคคล",
        SellerRegisterType: data.SellerRegisterType,
        IdentificationNo: data.IdentificationNo,
        MobilePhone: data.MobilePhone,
        DateOfRegisteration: data.DateOfRegisteration,
        NumberOfShares: Number(data.NumberOfShares) || 0,
        RegisteredCapital: data.RegisteredCapital,
        ListOfDirector: data.ListOfDirector || [],
        ListAuthorizedDirectors: data.ListAuthorizedDirectors || [],
        BussniesType: data.BussniesType,
        TaxpayerIdentificationNo: data.TaxpayerIdentificationNo,
        Region: data.Region,
        Buildings: data.Buildings,
        Room: data.Room,
        Floor: data.Floor,
        Village: data.Village,
        HouseNo: data.HouseNo,
        Swine: data.Swine,
        Alley: data.Alley,
        Road: data.Road,
        Province: data.Province,
        Districe: data.Districe,
        State: data.State,
        Post: data.Post,
        ContactName: data.ContactName,
        PhoneNumber: `${data.PhoneNumber}${data?.Per?.length > 0 ? " ต่อ " + data?.Per : ""
          }`,
        Email: data.Email,
        DigitalContact: data.DigitalContact,
        CertificateOfRegisteration: [...data.CertificateOfRegisteration],
        ExceptionDetail: data.ExceptionDetail || [],
        Certificate: data.Certificate || [],
        CertOfCompletion: data.CertOfCompletion || [],
        LogoPath: data.LogoPath ? data.LogoPath[0] : "",
        ServiceAndItem: data.ServiceAndItem,
        CatalogFilePath: data.CatalogFilePath,
        Mode: permissionData?.isAuthenticated ? "Update" : "Register",
        SellerCode: permissionData.isAuthenticated
          ? sellerDetail?.EmployeeCode
          : "",
        Capital: permissionData.isAuthenticated
          ? data.deliveryDate?.capital
          : "",
        Provincial: permissionData.isAuthenticated
          ? data.deliveryDate?.provincial
          : "",
      };

      const isCheckBlackList = await checkBlackList(formModel);
      // console.log("affter check blacklist = ", formModel);
      if (isCheckBlackList) {
        if (!permissionData?.isAuthenticated) {
          const response = await requestOTPAndSaveToDb({
            TelMobile: formModel.MobilePhone,
          });
          if (response.code === "200") {
            setConfirmOTP(response?.data);
            // console.log("formModel in befor submit = ", formModel);
            const clonedFormModel = JSON.parse(JSON.stringify(formModel));
            setDataOTP(clonedFormModel);
            setTimeout(() => {
              Swal.close();
              setShowModalOtp(true);
            }, 1000);
          } else {
            setTimeout(() => {
              Swal.fire({
                title: "ส่ง OTP ไม่สำเร็จ",
                icon: "error",
                confirmButtonText: `ยืนยัน`,
                confirmButtonColor: "#6598F6",
              });
            }, 1000);
          }
        } else {
          await submitAndOpenForm(formModel);
        }
      } else {
        Swal.close();
      }
    } catch (error) {
      console.error(error);
    }
  };



  const setForm = async (formModel: any) => {
    return new Promise((resolve) => {
      resolve(setFormModel(formModel));
    });
  };

  const checkBlackList = async (formData: any): Promise<boolean> => {
    let check = true;
    if (permissionData.isAuthenticated && permissionData.isAdmin) {
      check = true;
    } else {
      let response = await CheckBlackListForm(formData, "LegalEntity");
      if (response.data) {
        if (
          Compare(response.data.supplierType, "LegalEntity") &&
          (Compare(response.data.position, "Director") ||
            Compare(response.data.position, "AuthorDirector"))
        ) {
          await setForm(formData);
          setNameDirector(response.data);
          setShowDailogBlackList(true);
          check = false;
        } else {
          setNameDirector(undefined);
          setShowDailogBlackList(true);
          check = false;
        }
      }
    }
    return check;
  };

  //**Config Dailog */
  const openConfirmDailog = useCallback(() => {
    setShowDailogConfirm(true);
  }, []);

  const cancelDailog = useCallback(() => {
    setShowDailogConfirm(false);
  }, []);

  const onOk = () => {
    cancelDailog();
    setTimeout(() => {
      const certOfRegisteration = getValues("CertificateOfRegisteration");
      if (!certOfRegisteration || certOfRegisteration.length === 0) {
        setError(`CertificateOfRegisteration.${0}`, {
          type: "required",
          message: "กรุณาใส่ไฟล์แนบ",
        });
      } else {
        clearErrors(`CertificateOfRegisteration.${0}`);
      }
      const serviceAndItem = getValues("ServiceAndItem");
      let serviceErrorMsg = "";
      const isInvalid =
        !serviceAndItem ||
        serviceAndItem.length === 0 ||
        serviceAndItem.some((item) => {
          if (!item.ServiceItemType) {
            serviceErrorMsg = "กรุณาระบุประเภทสินค้า/บริการ";
            return true;
          }
          // "โปรดระบุ" เป็น sentinel value จาก API ที่มีความหมายเดียวกับ "อื่นๆ"
          const isOtherMode =
            item.ServiceItemType === "อื่นๆ" || item.ServiceItemName === "อื่นๆ" || item.ServiceItemName === "โปรดระบุ";
          if (isOtherMode && !item.OtherService?.trim()) {
            serviceErrorMsg = "กรุณาระบุประเภทสินค้า/บริการ และกรอกข้อมูลในช่อง \"ระบุบริการอื่นๆ\" ให้ครบถ้วน";
            return true;
          }
          if (!isOtherMode && !item.ServiceItemName) {
            serviceErrorMsg = "กรุณาระบุประเภทสินค้า/บริการ";
            return true;
          }
          return false;
        });

      if (isInvalid) {
        setError(`ServiceAndItem.${0}`, {
          type: "required",
          message: serviceErrorMsg,
        });
      } else {
        clearErrors(`ServiceAndItem.${0}`);
      }

      setErrosSize(initailErrors);
      handleSubmit(onsubmit)();
    }, 300);
  };

  //**File Upload */
  const onChangeFile = (
    e: React.ChangeEvent<HTMLInputElement>,
    key: keyof FIleUpload
  ) => {
    const files = e.currentTarget.files;
    if (files && files.length > 0) {
      const newValue: Files[] = Array.from(files).map((file) => {
        return { name: file.name, file: file };
      });
      setFileList((prevState: FIleUpload) => ({
        ...prevState,
        [key]: newValue,
      }));
    }
  };

  const showFileList = (params: Partial<FIleUpload>) => {
    setshowFiles((prev) => ({
      ...prev,
      ...params,
    }));
  };

  const showSizeErrors = (params: Partial<ErrosFIleUpload>) => {
    setErrosSize((prev) => ({
      ...prev,
      ...params,
    }));
  };

  const uploadFileHandler = (key: keyof FIleUpload) => {
    const files = fileList[key];
    console.log(files);
    let showFile: Files[] = [];
    if (key !== "LogoPath") {
      showFile = [...showFiles[key]];
    }
    let errors: Errors[] = [];
    let value: string[] = [];
    const maxSize = key === "LogoPath" || key === "CatalogFilePath" ? 20 : 2;
    const fileExtension = ["pdf", "jpg", "jpeg", "png", "docx", "doc"];
    if (files.length > 0) {
      files.forEach((file: any, i) => {
        const fileSizeMB = file.file && file.file?.size / 1024 / 1024;
        const includeFileExtension =
          file.file &&
          fileExtension.includes(file.name.split(".").pop().toLowerCase());
        if (fileSizeMB && fileSizeMB < maxSize && includeFileExtension) {
          showFile.push(file);
        } else if (!includeFileExtension) {
          errors.push({
            type: "validate",
            message: `ไม่สามารถอัพโหลดไฟล์ ${file.name} ได้`,
          });
        } else {
          errors.push({
            type: "validate",
            message: `ขนาดไฟล์ ${file.name} มากกว่าที่กำหนด`,
          });
        }
      });
    }
    showFile.forEach((data) => {
      value.push(data.name);
    });
    setValue(`${key}`, value);
    showFileList({ [key]: showFile });
    showSizeErrors({ [key]: errors });
    setFileList((prevState: FIleUpload) => ({
      ...prevState,
      [key]: [],
    }));
  };

  const deleteFileUpload = (key: keyof FIleUpload, name: string) => {
    const files = showFiles[key];
    let value: string[] = [];
    let showFile: Files[] = [];
    if (files.length > 0) {
      const newFile = files.filter((file) => file.name !== name);
      newFile.forEach((file) => {
        value.push(file.name);
        showFile.push(file);
      });
    }
    showFileList({ [key]: showFile });
    setValue(`${key}`, value);
  };

  const uploadFile = async (key: keyof FIleUpload) => {
    let results: any[] = [];
    if (showFiles[key] && showFiles[key].length > 0) {
      for (const item of showFiles[key]) {
        if (
          sellerDetail &&
          Array.isArray(sellerDetail[key]) &&
          sellerDetail[key].length > 0
        ) {
          for (let seller of sellerDetail[key]) {
            if (item.name === seller) {
              console.log("item.name = ", item.name);
              console.log("seller = ", seller);
            } else {
              const formData = new FormData();
              if (item.file) {
                formData.append("files", item.file);
                formData.append("Doclib", "TempAttachment");
                formData.append("docSet", generateQuickGuid());
                formData.append("fileDesc", `Upload file ${item.name}`);
                formData.append("actorID", "1");

                // Log each formData entry
                console.log(
                  `Form Data for ${item.name}:`,
                  [...formData.entries()]
                    .map((entry) => `${entry[0]}: ${entry[1]}`)
                    .join(", ")
                );
                const response = await UploadFileAttachFiles_v2(formData);
                results.push(response?.data);
              }
            }
          }
        } else {
          const formData = new FormData();
          if (item.file) {
            formData.append("files", item.file);
            formData.append("Doclib", "TempAttachment");
            formData.append("docSet", generateQuickGuid());
            formData.append("fileDesc", `Upload file ${item.file.name}`);
            formData.append("actorID", "1");
            //**Log list file upload */
            for (var pair of formData.entries()) {
              console.log(`Form Data[${key}] = `, pair[0] + ": " + pair[1]);
            }
            const response = await UploadFileAttachFiles_v2(formData);
            results.push(response?.data);
          }
        }
      }
    }
    console.log("results = ", results);
    return results;
  };

  const upload = async (data: any) => {
    const responseFilePath = {
      CertificateOfRegisteration: [] as any[],
      ExceptionDetail: [] as any[],
      Certificate: [] as any[],
      CertOfCompletion: [] as any[],
      LogoPath: [] as any[],
      CatalogFilePath: [] as any[],
    };
    try {
      if (data?.CertificateOfRegisteration) {
        if (
          sellerDetail?.CertificateOfRegisteration != null &&
          sellerDetail?.CertificateOfRegisteration.length > 0
        ) {
          for (let item of data.CertificateOfRegisteration) {
            if (sellerDetail?.CertificateOfRegisteration?.includes(item)) {
              responseFilePath.CertificateOfRegisteration.push({
                result: true,
                pathUrl: item,
                fileName: item,
              });
            }
          }
          const result = await uploadFile("CertificateOfRegisteration");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.CertificateOfRegisteration.push(uploadedItem);
            });
          }
        } else {
          const result = await uploadFile("CertificateOfRegisteration");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.CertificateOfRegisteration.push(uploadedItem);
            });
          }
        }
      }
      if (data?.ExceptionDetail) {
        if (
          sellerDetail?.ExceptionDetail != null &&
          sellerDetail?.ExceptionDetail.length > 0
        ) {
          for (let item of data.ExceptionDetail) {
            if (sellerDetail?.ExceptionDetail?.includes(item)) {
              responseFilePath.ExceptionDetail.push({
                result: true,
                pathUrl: item,
                fileName: item,
              });
            }
          }
          const result = await uploadFile("ExceptionDetail");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.ExceptionDetail.push(uploadedItem);
            });
          }
        } else {
          const result = await uploadFile("ExceptionDetail");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.ExceptionDetail.push(uploadedItem);
            });
          }
        }
      }
      if (data?.Certificate) {
        if (
          sellerDetail?.Certificate != null &&
          sellerDetail?.Certificate.length > 0
        ) {
          for (let item of data.Certificate) {
            if (sellerDetail?.Certificate?.includes(item)) {
              responseFilePath.Certificate.push({
                result: true,
                pathUrl: item,
                fileName: item,
              });
            }
          }
          const result = await uploadFile("Certificate");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.Certificate.push(uploadedItem);
            });
          }
        } else {
          const result = await uploadFile("Certificate");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.Certificate.push(uploadedItem);
            });
          }
        }
      }
      if (data?.CertOfCompletion) {
        if (
          sellerDetail?.CertOfCompletion != null &&
          sellerDetail?.CertOfCompletion.length > 0
        ) {
          for (let item of data.CertOfCompletion) {
            if (sellerDetail?.CertOfCompletion?.includes(item)) {
              responseFilePath.CertOfCompletion.push({
                result: true,
                pathUrl: item,
                fileName: item,
              });
            }
          }
          const result = await uploadFile("CertOfCompletion");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.CertOfCompletion.push(uploadedItem);
            });
          }
        } else {
          const result = await uploadFile("CertOfCompletion");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.CertOfCompletion.push(uploadedItem);
            });
          }
        }
      }
      if (data?.LogoPath) {
        if (sellerDetail?.LogoPath != null) {
          if (sellerDetail?.LogoPath?.includes(data?.LogoPath)) {
            responseFilePath.LogoPath.push({
              result: true,
              pathUrl: item,
              fileName: item,
            });
          }
          const result = await uploadFile("LogoPath");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.LogoPath.push(uploadedItem);
            });
          }
        } else {
          const result = await uploadFile("LogoPath");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.LogoPath.push(uploadedItem);
            });
          }
        }
      }
      if (data?.CatalogFilePath) {
        if (sellerDetail?.CatalogFilePath != null) {
          if (sellerDetail?.CatalogFilePath?.includes(data?.CatalogFilePath)) {
            responseFilePath.CatalogFilePath.push({
              result: true,
              pathUrl: item,
              fileName: item,
            });
          }
          const result = await uploadFile("CatalogFilePath");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.CatalogFilePath.push(uploadedItem);
            });
          }
        } else {
          const result = await uploadFile("CatalogFilePath");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.CatalogFilePath.push(uploadedItem);
            });
          }
        }
      }
    } catch (err: any) {
      console.error(`Upload File ${err}`);
    }

    console.log("responseFilePath = ", JSON.stringify(responseFilePath));
    return responseFilePath;
  };

  const cancelDailogBlackList = useCallback(() => {
    setShowDailogBlackList(false);
  }, []);

  const onOkBlackList = async () => {
    if (formModel) {
      cancelDailogBlackList();
      if (!permissionData?.isAuthenticated) {
        Swal.fire({
          title: "กำลังดำเนินการ...",
          text: "กรุณารอสักครู่...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        const response = await requestOTPAndSaveToDb({
          TelMobile: formModel.MobilePhone,
        });
        setTimeout(() => {
          if (response.code === "200") {
            setConfirmOTP(response?.data);
            setDataOTP(formModel);
            setTimeout(() => {
              Swal.close();
              setShowModalOtp(true);
            }, 1000);
          } else {
            setTimeout(() => {
              Swal.fire({
                title: "ส่ง OTP ไม่สำเร็จ",
                icon: "error",
                confirmButtonText: `ยืนยัน`,
                confirmButtonColor: "#6598F6",
              });
            }, 1000);
          }
        }, 1000);
      } else {
        Swal.fire({
          title: "กำลังส่งข้อมูล...",
          text: "กรุณารอสักครู่...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        await submitAndOpenForm(formModel);
      }
    }
  };

  const showListName = (
    <div style={{ fontSize: "1.1rem" }}>
      <>
        <img
          src={Cancel}
          alt="Cancel"
          style={{ width: "200px", height: "200px" }}
        />
        <div>
          {" "}
          มีรายชื่อกรรมการ <br />
          หรือรายชื่อกรรมการผู้มีอำนาจผูกพันนิติบุคคล
        </div>
      </>
      <span
        style={{
          display: "flex",
          flexDirection: "column",
          textAlign: "center",
        }}
      >
        {nameDirector?.blacklist.map((data: BlacklistItem, i) => {
          return <span key={i}>{`คุณ ${data.blackListFullName} `}</span>;
        })}
      </span>{" "}
      เป็น Blacklist ดำเนินการต่อหรือไม่
    </div>
  );

  const dailogContinue = useMemo(() => {
    return (
      <LegalEntiryBlackListModal
        visible={showDailogBlackList}
        onCancel={cancelDailogBlackList}
        onOk={onOkBlackList}
        checkBlackList={nameDirector ? true : false}
        children={showListName}
      />
    );
  }, [nameDirector, showDailogBlackList]);

  const itemOptions = (i: number) => {
    const filterCategory = item?.filter(
      (it) => it.category === watch(`ServiceAndItem.${i}.ServiceItemType`)
    );
    const groupByType = filterCategory?.reduce(
      (
        acc: {
          [key: string]: {
            label: string;
            options: { label: string; value: string }[];
          };
        },
        currentItem
      ) => {
        if (!acc[currentItem.type]) {
          acc[currentItem.type] = {
            label: currentItem.type,
            options: [],
          };
        }
        acc[currentItem.type].options.push({
          label: currentItem.label,
          value: currentItem.label,
        });
        return acc;
      },
      {} as {
        [key: string]: {
          label: string;
          options: { label: string; value: string }[];
        };
      }
    );

    const filterValue = groupByType ? Object.values(groupByType) : [];

    return filterValue;
  };

  const onCloseOTP = useCallback(() => {
    setShowModalOtp(false);
  }, []);

  const onOkOTP = async (isOtpCorrect: boolean) => {
    console.log("dataOTP in site function = ", dataOTPToSet);
    if (isOtpCorrect && dataOTPToSet) {
      onCloseOTP();
      setTimeout(() => {
        Swal.fire({
          title: "กำลังส่งข้อมูลข้อมูล...",
          text: "กรุณารอสักครู่...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
      }, 200);
      await submitAndOpenForm(dataOTPToSet);
    }
  };

  const buddhistDatePicker = (dateStr: string) => {
    const [d, m, y] = dateStr.split("-");
    return `${d}-${m}-${Number(y) - 543}`;
  };

  return (
    <>
      <form onSubmit={handleSubmit(onsubmit)}>
        <div style={{ display: "grid", rowGap: "20px" }}>
          <div style={{ borderRadius: "8px" }}>
            <div className="container-input">
              <div className="header-content">บันทึกข้อมูลผู้ค้านิติบุคคล</div>
              <div className="content-form">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "0.5fr 1.5fr",
                    gridTemplateRows: "auto",
                    rowGap: "8px",
                  }}
                >
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    ชื่อนิติบุคคล
                  </label>
                  <div>
                    <input
                      type="text"
                      className={`${errors.SellerNameTh && "error-input"}`}
                      {...register("SellerNameTh", {
                        required: "กรุณากรอกชื่อผู้นิติบุคคล",
                      })}
                      disabled={
                        permissionData?.isAuthenticated &&
                        !permissionData?.isSeller &&
                        !permissionData?.isAdmin
                      }
                    // Fix Supplier list detail and Add permission

                    // มี Authen GuIdVerify,
                    // ต้องไม่ใช่ Seller ,
                    // ต้องไม่ใช่ isAdmin
                    />
                    {errors.SellerNameTh && (
                      <p className="error-message">
                        {errors.SellerNameTh.message}
                      </p>
                    )}
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    ชื่อนิติบุคคล(ภาษาอังกฤษ)
                  </label>
                  <div>
                    <input
                      type="text"
                      className={`${errors.SellerNameTh && "error-input"}`}
                      {...register("SellerNameEn", {
                        required: "กรุณากรอกชื่อผู้นิติบุคคล(ภาษาอังกฤษ)",
                      })}
                      disabled={
                        permissionData?.isAuthenticated &&
                        !permissionData?.isSeller &&
                        !permissionData?.isAdmin
                      }
                    />
                    {errors.SellerNameEn && (
                      <p className="error-message">
                        {errors.SellerNameEn.message}
                      </p>
                    )}
                  </div>

                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    ประเภทนิติบุคคล
                  </label>
                  <div>
                    <Controller
                      control={control}
                      name="SellerRegisterType"
                      rules={{ required: "กรุณาเลือกประเภทนิติบุคคล" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          showSearch
                          placeholder="โปรดเลือกประเภทนิติบุคคล"
                          optionFilterProp="children"
                          style={{ width: 120 }}
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          options={
                            characteristics?.map((data) => {
                              return {
                                label: data.Value1,
                                value: data.Value1,
                              };
                            }) || []
                          }
                          disabled={
                            permissionData.isAuthenticated &&
                            !permissionData.isSeller
                          }
                        />
                      )}
                    />
                    {errors.SellerRegisterType && (
                      <p className="error-message">
                        {errors.SellerRegisterType.message}
                      </p>
                    )}
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    เลขทะเบียนนิติบุคคล
                  </label>
                  <div>
                    <input
                      type="text"
                      maxLength={13}
                      className={`${errors.IdentificationNo && "error-input"}`}
                      {...register("IdentificationNo", {
                        required: "กรุณากรอกเลขทะเบียนนิติบุคคล",
                      })}
                      disabled={
                        permissionData.isAuthenticated &&
                        !permissionData.isSeller
                      }
                    />
                    {errors.IdentificationNo && (
                      <p className="error-message">
                        {errors.IdentificationNo.message}
                      </p>
                    )}
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    หมายเลขโทรศัพท์ <br />
                    (เพื่อใช้ยืนยันตัวตน)
                  </label>
                  <div>
                    <input
                      type="text"
                      className={`${errors.MobilePhone && "error-input"}`}
                      {...register("MobilePhone", {
                        required: "กรุณากรอกเบอร์มือถือสำหรับยืนยันตัวตน",
                        pattern: {
                          value: /^(\+?\d{1,3})?(0\d{8,9})$/,
                          message: "กรุณากรอกเบอร์มือถือให้ถูกต้อง",
                        },
                      })}
                      disabled={
                        permissionData.isAuthenticated &&
                        !permissionData.isSeller
                      }
                      maxLength={10}
                    />
                    {errors.MobilePhone && (
                      <p className="error-message">
                        {errors.MobilePhone.message}
                      </p>
                    )}
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    วันเดือนปีที่จดทะเบียน
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "200px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <Controller
                      name="DateOfRegisteration"
                      control={control}
                      rules={{ required: "กรุณาเลือกวันเดือนปีที่จดทะเบียน" }}
                      render={({ field }) => {
                        return (
                          <div>
                            <DatePicker
                              value={field.value ? dayjs(buddhistDatePicker(field.value), "DD-MM-YYYY") : null}
                              placeholder="ระบุวันที่"
                              locale={datePickerTh}
                              picker="date"
                              disabled={
                                permissionData.isAuthenticated &&
                                !permissionData.isSeller
                              }
                              onChange={(date, dateString) => {
                                console.log(date, dateString);
                                field.onChange(dateString)
                              }}
                              format="DD-MM-BBBB"
                            />
                            {errors.DateOfRegisteration && (
                              <p className="error-message">
                                {errors.DateOfRegisteration.message}
                              </p>
                            )}
                          </div>
                        );
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <label htmlFor="" className="label">
                        จำนวนหุ้น
                      </label>
                      <input
                        type="number"
                        style={{ maxWidth: "70%" }}
                        {...register("NumberOfShares")}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                      <label htmlFor="" className="label" style={{ margin: 0 }}>
                        หุ้น
                      </label>
                    </div>
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    เงินทุนทะเบียน
                  </label>
                  <div>
                    <input
                      type="number"
                      className={`${errors.RegisteredCapital && "error-input"}`}
                      {...register("RegisteredCapital", {
                        required: "กรุณากรอกเงินทุนทะเบียน",
                      })}
                      disabled={
                        permissionData.isAuthenticated &&
                        !permissionData.isSeller
                      }
                    />
                    {errors.RegisteredCapital && (
                      <p className="error-message">
                        {errors.RegisteredCapital.message}
                      </p>
                    )}
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    รายชื่อกรรมการ
                  </label>
                  <div>
                    {fieldsDir.map((data, i) => {
                      return (
                        <div
                          key={data.id}
                          style={{
                            display: "flex",
                            columnGap: "4px",
                            marginBottom: "4px",
                          }}
                        >
                          <div
                            style={{
                              width: "100%",
                            }}
                          >
                            <Controller
                              name={`ListOfDirector.${i}.DirectorTitle`}
                              control={control}
                              // rules={{ required: "กรุณาเลือกคำนำหน้า" }}
                              render={({ field }) => {
                                return (
                                  <Select
                                    {...field}
                                    showSearch
                                    placeholder="เลือกคำนำหน้า"
                                    optionFilterProp="children"
                                    style={{
                                      maxHeight: "32px",
                                      height: "100%",
                                    }}
                                    filterOption={(input, option) =>
                                      (option?.label ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    options={
                                      titleName?.map((data) => {
                                        return {
                                          label: data.Value1,
                                          value: data.Value1,
                                        };
                                      }) || []
                                    }
                                    disabled={
                                      permissionData.isAuthenticated &&
                                      !permissionData.isSeller
                                    }
                                  />
                                );
                              }}
                            />
                            {errors.ListOfDirector?.[i]?.DirectorTitle && (
                              <p className="error-message">
                                {
                                  errors.ListOfDirector?.[i]?.DirectorTitle
                                    .message
                                }
                              </p>
                            )}
                          </div>

                          <div style={{ width: "100%" }}>
                            <Controller
                              name={`ListOfDirector.${i}.DirectorFullName`}
                              control={control}
                              // rules={{ required: "กรุณาชื่อ-สกุล" }}
                              render={({ field }) => {
                                return (
                                  <input
                                    {...field}
                                    type="text"
                                    className={`${errors.SellerNameTh && "error-input"
                                      }`}
                                    placeholder="ชื่อ-สกุล"
                                    style={{
                                      maxWidth: "100%",
                                      paddingLeft: "10px",
                                    }}
                                    disabled={
                                      permissionData.isAuthenticated &&
                                      !permissionData.isSeller
                                    }
                                  />
                                );
                              }}
                            />
                            {errors.ListOfDirector?.[i]?.DirectorFullName && (
                              <p className="error-message">
                                {
                                  errors.ListOfDirector?.[i]?.DirectorFullName
                                    .message
                                }
                              </p>
                            )}
                          </div>
                          <div style={{ width: "100%" }}>
                            <Controller
                              name={`ListOfDirector.${i}.DirectorIdentification`}
                              control={control}
                              // rules={{ required: "กรุณาระบุเลขบัตรประชาชน" }}
                              render={({ field }) => {
                                return (
                                  <input
                                    {...field}
                                    type="text"
                                    maxLength={13}
                                    className={`${errors.SellerNameTh && "error-input"
                                      }`}
                                    placeholder="ระบุเลขบัตรประชาชน"
                                    style={{
                                      maxWidth: "100%",
                                      paddingLeft: "10px",
                                    }}
                                    disabled={
                                      permissionData.isAuthenticated &&
                                      !permissionData.isSeller
                                    }
                                  />
                                );
                              }}
                            />
                            {errors.ListOfDirector?.[i]
                              ?.DirectorIdentification && (
                                <p className="error-message">
                                  {
                                    errors.ListOfDirector?.[i]
                                      ?.DirectorIdentification.message
                                  }
                                </p>
                              )}
                          </div>
                          {fieldsDir.length - 1 === i && (
                            <Button
                              type="primary"
                              shape="default"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "#6598F6",
                                borderColor: "#6598F6",
                                borderRadius: "6px",
                              }}
                              disabled={
                                permissionData.isAuthenticated &&
                                !permissionData.isSeller
                              }
                              onClick={() => {
                                let newDirector: DirectorList = {
                                  DirectorPosition: undefined,
                                  DirectorTitle: undefined,
                                  DirectorFullName: undefined,
                                  DirectorIdentification: undefined,
                                };
                                appendDir(newDirector);
                              }}
                            >
                              <PlusCircleOutlined rev={undefined} />
                            </Button>
                          )}
                          {fieldsDir.length > 1 &&
                            fieldsDir.length - 1 !== i && (
                              <Button
                                type="primary"
                                shape="default"
                                disabled={
                                  permissionData.isAuthenticated &&
                                  !permissionData.isSeller
                                }
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: "#c95559",
                                  borderColor: "#c95559",
                                  borderRadius: "6px",
                                }}
                                onClick={() => {
                                  removeDir(i);
                                }}
                              >
                                <DeleteOutlined rev={undefined} />
                              </Button>
                            )}
                        </div>
                      );
                    })}
                  </div>
                  <label htmlFor="" className="label">
                    รายชื่อกรรมการผู้มีอำนาจ
                    <br />
                    ผูกพันนิติบุคคล
                  </label>
                  <div>
                    {fieldsAtrDirector.map((data, i) => {
                      return (
                        <div
                          key={data.id}
                          style={{
                            display: "flex",
                            rowGap: "4px",
                            alignItems: "center",
                            marginBottom: "4px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              columnGap: "4px",
                              width: "100%",
                            }}
                          >
                            <Controller
                              name={`ListAuthorizedDirectors.${i}.AuthorPosition`}
                              control={control}
                              render={({ field }) => {
                                return (
                                  <Select
                                    {...field}
                                    placeholder="โปรดระบุตำแหน่ง"
                                    style={{ maxWidth: "160px" }}
                                    allowClear
                                    options={
                                      excutivePosition?.map((data) => {
                                        return {
                                          label: data.Value1,
                                          value: data.Value1,
                                        };
                                      }) || []
                                    }
                                    disabled={
                                      permissionData.isAuthenticated &&
                                      !permissionData.isSeller
                                    }
                                  />
                                );
                              }}
                            />
                            <Controller
                              name={`ListAuthorizedDirectors.${i}.AuthorTitle`}
                              control={control}
                              render={({ field }) => {
                                return (
                                  <Select
                                    {...field}
                                    showSearch
                                    placeholder="เลือกคำนำหน้า"
                                    optionFilterProp="children"
                                    style={{ width: 120 }}
                                    filterOption={(input, option) =>
                                      (option?.label ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    options={
                                      titleName?.map((data) => {
                                        return {
                                          label: data.Value1,
                                          value: data.Value1,
                                        };
                                      }) || []
                                    }
                                    disabled={
                                      permissionData.isAuthenticated &&
                                      !permissionData.isSeller
                                    }
                                  />
                                );
                              }}
                            />
                            <Controller
                              name={`ListAuthorizedDirectors.${i}.AuthorFullName`}
                              control={control}
                              render={({ field }) => {
                                return (
                                  <input
                                    {...field}
                                    type="text"
                                    placeholder="ชื่อ-สกุล"
                                    style={{
                                      maxWidth: "50%",
                                      paddingLeft: "10px",
                                      minHeight: "32px",
                                    }}
                                    disabled={
                                      permissionData.isAuthenticated &&
                                      !permissionData.isSeller
                                    }
                                  />
                                );
                              }}
                            />

                            <Controller
                              name={`ListAuthorizedDirectors.${i}.AuthorIdentification`}
                              control={control}
                              render={({ field }) => {
                                return (
                                  <input
                                    {...field}
                                    type="text"
                                    maxLength={13}
                                    placeholder="ระบุเลขบัตรประชาชน"
                                    style={{
                                      maxWidth: "50%",
                                      paddingLeft: "10px",
                                      minHeight: "32px",
                                    }}
                                    disabled={
                                      permissionData.isAuthenticated &&
                                      !permissionData.isSeller
                                    }
                                  />
                                );
                              }}
                            />
                            {fieldsAtrDirector.length - 1 === i && (
                              <Button
                                type="primary"
                                shape="default"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: "#6598F6",
                                  borderColor: "#6598F6",
                                  borderRadius: "6px",
                                }}
                                disabled={
                                  permissionData.isAuthenticated &&
                                  !permissionData.isSeller
                                }
                                onClick={() => {
                                  let newDirector: AuthorizedDirector = {
                                    AuthorPosition: undefined,
                                    AuthorTitle: undefined,
                                    AuthorFullName: undefined,
                                    AuthorIdentification: undefined,
                                    AuthorType: undefined,
                                  };
                                  appendAtrDirector(newDirector);
                                }}
                              >
                                <PlusCircleOutlined rev={undefined} />
                              </Button>
                            )}

                            {fieldsAtrDirector.length > 1 &&
                              fieldsAtrDirector.length - 1 !== i && (
                                <Button
                                  type="primary"
                                  shape="default"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#c95559",
                                    borderColor: "#c95559",
                                    borderRadius: "6px",
                                  }}
                                  disabled={
                                    permissionData.isAuthenticated &&
                                    !permissionData.isSeller
                                  }
                                  onClick={() => {
                                    removeAtrDirector(i);
                                  }}
                                >
                                  <DeleteOutlined rev={undefined} />
                                </Button>
                              )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    ประเภทกิจการ
                  </label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "bold",
                    }}
                  >
                    <div>
                      <Controller
                        name="BussniesType"
                        control={control}
                        rules={{ required: "กรุณาเลือกประเภทกิจการ" }}
                        render={({ field }) => {
                          return (
                            <Radio.Group
                              className={`${errors.BussniesType && "error-input"
                                }`}
                              value={field.value}
                              onChange={(e) => field.onChange(e.target.value)}
                              disabled={
                                permissionData.isAuthenticated &&
                                !permissionData.isSeller
                              }
                            >
                              <Radio
                                value={"ผลิต"}
                                style={{ fontSize: "1.1rem" }}
                              >
                                ผลิต
                              </Radio>
                              <Radio
                                value={"ส่งออก"}
                                style={{ fontSize: "1.1rem" }}
                              >
                                ส่งออก
                              </Radio>
                              <Radio
                                value={"ขายส่ง"}
                                style={{ fontSize: "1.1rem" }}
                              >
                                ขายส่ง
                              </Radio>
                              <Radio
                                value={"ขายปลีก"}
                                style={{ fontSize: "1.1rem" }}
                              >
                                ขายปลีก
                              </Radio>
                              <Radio
                                value={"ให้บริการ"}
                                style={{ fontSize: "1.1rem" }}
                              >
                                ให้บริการ
                              </Radio>
                            </Radio.Group>
                          );
                        }}
                      />
                      {errors.BussniesType && (
                        <p className="error-message">
                          {errors.BussniesType.message}
                        </p>
                      )}
                    </div>
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    เลขประจำตัวผู้เสียภาษีอากร
                  </label>
                  <div>
                    <input
                      type="text"
                      className={`${errors.TaxpayerIdentificationNo && "error-input"
                        }`}
                      {...register("TaxpayerIdentificationNo", {
                        required: "กรุณากรอกเลขประจำตัวผู้เสียภาษีอากร",
                      })}
                      disabled={
                        permissionData.isAuthenticated &&
                        !permissionData.isSeller
                      }
                    />
                    {errors.TaxpayerIdentificationNo && (
                      <p className="error-message">
                        {errors.TaxpayerIdentificationNo.message}
                      </p>
                    )}
                  </div>

                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    ที่ตั้งสำนักงานใหญ่
                  </label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "bold",
                    }}
                  >
                    <div>
                      <Controller
                        name="Region"
                        control={control}
                        rules={{ required: "กรุณาเลือกที่ตั้งสำนักงานใหญ่" }}
                        render={({ field }) => (
                          <Radio.Group
                            className={`${errors.Region && "error-input"}`}
                            value={field.value}
                            onChange={(e) => field.onChange(e.target.value)}
                            disabled={
                              permissionData.isAuthenticated &&
                              !permissionData.isSeller
                            }
                          >
                            <Radio
                              value={"ประเทศไทย"}
                              style={{ fontSize: "1.1rem" }}
                            >
                              ประเทศไทย
                            </Radio>
                            <Radio
                              value={"ต่างประเทศ"}
                              style={{ fontSize: "1.1rem" }}
                            >
                              ต่างประเทศ
                            </Radio>
                          </Radio.Group>
                        )}
                      />
                      {errors.Region && (
                        <p className="error-message">{errors.Region.message}</p>
                      )}
                    </div>
                  </div>
                  <label htmlFor="" className="label">
                    ชื่ออาคาร
                  </label>
                  <input
                    type="text"
                    {...register("Buildings")}
                    disabled={
                      permissionData.isAuthenticated && !permissionData.isSeller
                    }
                  />
                  <label htmlFor="" className="label">
                    ห้องเลขที่
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "200px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <input
                      type="text"
                      {...register("Room")}
                      disabled={
                        permissionData.isAuthenticated &&
                        !permissionData.isSeller
                      }
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <label htmlFor="" className="label">
                        ชั้นที่
                      </label>
                      <input
                        type="text"
                        style={{ maxWidth: "80%" }}
                        {...register("Floor")}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                    </div>
                  </div>
                  <label htmlFor="" className="label">
                    ชื่อหมู่บ้าน
                  </label>
                  <input
                    type="text"
                    {...register("Village")}
                    disabled={
                      permissionData.isAuthenticated && !permissionData.isSeller
                    }
                  />
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    เลขที่
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "200px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <input
                        type="text"
                        className={`${errors.HouseNo && "error-input"}`}
                        {...register("HouseNo", {
                          required: "กรุณากรอกบ้านเลขที่",
                        })}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                      {errors.HouseNo && (
                        <p className="error-message">
                          {errors.HouseNo.message}
                        </p>
                      )}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <label htmlFor="" className="label">
                        หมู่ที่
                      </label>
                      <input
                        type="text"
                        style={{ maxWidth: "80%" }}
                        {...register("Swine")}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                    </div>
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    ตรอก/ซอย
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "200px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      {" "}
                      <input
                        type="text"
                        className={`${errors.Alley && "error-input"}`}
                        {...register("Alley", {
                          required: "กรุณากรอก ตรอก/ซอย",
                        })}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                      {errors.Alley && (
                        <p className="error-message">{errors.Alley.message}</p>
                      )}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <label htmlFor="" className="label">
                        ถนน
                      </label>
                      <input
                        type="text"
                        style={{ maxWidth: "80%" }}
                        {...register("Road")}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                    </div>
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    จังหวัด
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "200px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <Controller
                        name="Province"
                        control={control}
                        rules={{ required: "กรุณาเลือกจังหวัด" }}
                        render={({ field }) => {
                          return (
                            <Select
                              {...field}
                              showSearch
                              optionFilterProp="children"
                              style={{ width: 120 }}
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              disabled={
                                permissionData.isAuthenticated &&
                                !permissionData.isSeller
                              }
                              options={
                                provinces?.map((p) => {
                                  return {
                                    value: p.Province,
                                    label: p.Province,
                                  };
                                }) || []
                              }
                            />
                          );
                        }}
                      />
                      {errors.Province && (
                        <p className="error-message">
                          {errors.Province.message}
                        </p>
                      )}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <label htmlFor="" className="label">
                        <span style={{ color: "red" }}>*&nbsp;</span>
                        อำเภอ/เขต
                      </label>

                      <Controller
                        name="Districe"
                        control={control}
                        rules={{ required: "กรุณาเลือก อำเภอ/เขต" }}
                        render={({ field }) => {
                          return (
                            <div style={{ width: "70%" }}>
                              <Select
                                {...field}
                                showSearch
                                optionFilterProp="children"
                                style={{ width: 120 }}
                                filterOption={(input, option) =>
                                  (option?.label ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                disabled={
                                  permissionData.isAuthenticated &&
                                  !permissionData.isSeller
                                }
                                options={
                                  distrinces?.map((d) => {
                                    return {
                                      label: d.Districe,
                                      value: d.Districe,
                                    };
                                  }) || []
                                }
                              />
                              {errors.State && (
                                <p className="error-message">
                                  {errors.State.message}
                                </p>
                              )}
                            </div>
                          );
                        }}
                      />
                    </div>
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    ตำบล/แขวง
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "200px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <Controller
                      name="State"
                      control={control}
                      rules={{ required: "กรุณาเลือก ตำบล/แขวง" }}
                      render={({ field }) => {
                        return (
                          <div>
                            <Select
                              {...field}
                              showSearch
                              optionFilterProp="children"
                              style={{ width: "100%" }}
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              disabled={
                                permissionData.isAuthenticated &&
                                !permissionData.isSeller
                              }
                              options={
                                states?.map((s) => {
                                  return { label: s.State, value: s.State };
                                }) || []
                              }
                            />
                            {errors.Districe && (
                              <p className="error-message">
                                {errors.Districe.message}
                              </p>
                            )}
                          </div>
                        );
                      }}
                    />

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <label htmlFor="" className="label">
                        <span style={{ color: "red" }}>*&nbsp;</span>
                        รหัสไปรษณีย์
                      </label>

                      <div style={{ width: "70%" }}>
                        <input
                          readOnly
                          type="number"
                          className={`${errors.Post && "error-input"}`}
                          {...register("Post", {
                            required: "กรุณากรอกรหัสไปรษณีย์",
                          })}
                          disabled={
                            permissionData.isAuthenticated &&
                            !permissionData.isSeller
                          }
                          value={post}
                          onChange={(e) => {
                            setPost(Number(e.target.value));
                            setValue("Post", JSON.stringify(e.target.value));
                          }}
                        />
                        {errors.Post && (
                          <p className="error-message">{errors.Post.message}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    ชื่อผู้ติดต่อ
                  </label>
                  <div>
                    <input
                      type="text"
                      className={`${errors.ContactName && "error-input"}`}
                      {...register("ContactName", {
                        required: "กรุณากรอกชื่อผู้ติดต่อ",
                      })}
                      disabled={
                        permissionData.isAuthenticated &&
                        !permissionData.isSeller
                      }
                    />
                    {errors.ContactName && (
                      <p className="error-message">
                        {errors.ContactName.message}
                      </p>
                    )}
                  </div>

                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    หมายเลขโทรศัพท์
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "500px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                      }}
                    >
                      <input
                        placeholder="021234567, 051236895"
                        type="text"
                        className={`${errors.PhoneNumber && "error-input"}`}
                        {...register("PhoneNumber", {
                          required: "กรุณากรอกหมายเลขโทรศัพท์",
                          pattern: {
                            value:
                              /^(\+?\d{1,3})?(0\d{8,9})$/,
                            message: "กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง",
                          },
                        })}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                        maxLength={10}
                      />
                      {errors.PhoneNumber && (
                        <p className="error-message">
                          {errors.PhoneNumber.message}
                        </p>
                      )}
                      <p
                        style={{
                          fontSize: "1.1rem",
                          fontWeight: "bold",
                          margin: 0,
                        }}
                      >
                        ต่อ
                      </p>
                      <input
                        type="text"
                        placeholder="123, 56"
                        className={`${errors.PhoneNumber && "error-input"}`}
                        {...register("Per")}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        width: "100%",
                      }}
                    >
                      <p style={{ fontSize: "0.9rem", margin: 0 }}>
                        หมายเลขโทรศัพท์ 0-2123-4567 ต่อ 1234
                      </p>
                    </div>
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    e-mail
                  </label>
                  <div>
                    <input
                      type="text"
                      className={`${errors.Email && "error-input"}`}
                      // disabled={checkIsSupplier? true:false}
                      {...register("Email", {
                        required: "กรุณากรอก email",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "กรุณากรอก email ให้ถูกต้อง",
                        },
                      })}
                      disabled={
                        permissionData.isAuthenticated &&
                        !permissionData.isSeller
                      }
                    />
                    {errors.Email && (
                      <p className="error-message">{errors.Email.message}</p>
                    )}
                  </div>
                  <label htmlFor="" className="label">
                    ช่องทางการประชาสัมพันธ์ <br />
                    (Website ,Facebook, อื่นๆ)
                  </label>
                  <input
                    type="text"
                    {...register("DigitalContact")}
                    disabled={
                      permissionData.isAuthenticated && !permissionData.isSeller
                    }
                  />
                  <label
                    htmlFor=""
                    className="label"
                    style={{ lineHeight: "1" }}
                  >
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    หนังสือรับรองการจดทะเบียนนิติบุคคล
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "400px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <div
                        style={{
                          minHeight: "90px",
                          border: "1px solid black",
                          borderRadius: "6px",
                          padding: "10px",
                          borderColor: "#C5C5C5",
                        }}
                      >
                        {showFiles.CertificateOfRegisteration?.map((n, i) => {
                          return (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                alignItems: "cemter",
                                gap: "5px",
                                marginBottom: "4px",
                              }}
                            >
                              <Button
                                type="primary"
                                shape="circle"
                                size="small"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: "#c95559",
                                  borderColor: "#c95559",
                                }}
                                disabled={
                                  permissionData.isAuthenticated &&
                                  !permissionData.isSeller
                                }
                                onClick={() =>
                                  deleteFileUpload(
                                    "CertificateOfRegisteration",
                                    n.name
                                  )
                                }
                              >
                                <CloseOutlined
                                  style={{
                                    color: "#ffff",
                                  }}
                                  rev={undefined}
                                />
                              </Button>
                              <div key={i} className="list-file">
                                {i + 1}. {n.name}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      {errors.CertificateOfRegisteration?.[0] &&
                        showFiles.CertificateOfRegisteration.length === 0 && (
                          <p className="error-message">
                            {errors.CertificateOfRegisteration?.[0].message}
                          </p>
                        )}
                      {errosSize.CertificateOfRegisteration.length > 0 &&
                        errosSize.CertificateOfRegisteration.map((err, i) => {
                          return (
                            <p key={i} className="error-message">
                              {err.message}
                            </p>
                          );
                        })}
                    </span>
                    <div style={{ position: "relative" }}>
                      <input
                        type="file"
                        multiple
                        onChange={(e) =>
                          onChangeFile(e, "CertificateOfRegisteration")
                        }
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                      <Button
                        onClick={() =>
                          uploadFileHandler("CertificateOfRegisteration")
                        }
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                        style={{
                          position: "absolute",
                          right: 0,
                          backgroundColor: "#6598F6",
                          color: "white",
                          borderRadius: "6px",
                        }}
                      >
                        Upload File
                      </Button>
                      <br />
                      <p
                        style={{
                          fontSize: "0.9rem",
                          marginBottom: 0,
                          marginTop: 10,
                        }}
                      >
                        เอกสารต้องแนบเป็นไฟล์ pdf (ขนาดไม่เกิน 2 MB)
                      </p>
                    </div>
                  </div>
                  <label
                    htmlFor=""
                    className="label"
                    style={{ lineHeight: "1" }}
                  >
                    ประวัติการได้รับข้อยกเว้น <br />
                    (ทางกฏหมาย หรือ เอกสิทธิ์พิเศษ ทางกฏหมาย <br />
                    หรือ ประวัติการติดบัญชีรายชื่อผู้ทิ้งงาน)
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "400px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <div
                        style={{
                          minHeight: "90px",
                          border: "1px solid black",
                          borderRadius: "6px",
                          borderColor: "#C5C5C5",
                          padding: "10px",
                        }}
                      >
                        {showFiles.ExceptionDetail?.map((n, i) => {
                          return (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                alignItems: "cemter",
                                gap: "5px",
                                marginBottom: "4px",
                              }}
                            >
                              <Button
                                type="primary"
                                shape="circle"
                                size="small"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: "#c95559",
                                  borderColor: "#c95559",
                                  // borderRadius: "6px",
                                }}
                                onClick={() =>
                                  deleteFileUpload("ExceptionDetail", n.name)
                                }
                              >
                                <CloseOutlined
                                  style={{
                                    color: "#ffff",
                                  }}
                                  rev={undefined}
                                />
                              </Button>
                              <div key={i} className="list-file">
                                {i + 1}. {n.name}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      {errosSize.ExceptionDetail.length > 0 &&
                        errosSize.ExceptionDetail.map((err, i) => {
                          return (
                            <p key={i} className="error-message">
                              {err.message}
                            </p>
                          );
                        })}
                    </span>
                    <div style={{ position: "relative" }}>
                      <input
                        type="file"
                        multiple
                        onChange={(e) => onChangeFile(e, "ExceptionDetail")}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                      <Button
                        onClick={() => uploadFileHandler("ExceptionDetail")}
                        style={{
                          position: "absolute",
                          right: 0,
                          backgroundColor: "#6598F6",
                          color: "white",
                          borderRadius: "6px",
                        }}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      >
                        Upload File
                      </Button>
                      <br />
                      <p
                        style={{
                          fontSize: "0.9rem",
                          marginBottom: 0,
                          marginTop: 10,
                        }}
                      >
                        เอกสารต้องแนบเป็นไฟล์ pdf (ขนาดไม่เกิน 2 MB)
                      </p>
                    </div>
                  </div>
                  <label
                    htmlFor=""
                    className="label"
                    style={{ lineHeight: "1" }}
                  >
                    แนบใบรับรอง <br />
                    เช่น Regulation Certified, Certificate, <br />
                    Document, ISO
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "400px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <div
                        style={{
                          minHeight: "90px",
                          border: "1px solid black",
                          borderRadius: "6px",
                          borderColor: "#C5C5C5",
                          padding: "10px",
                        }}
                      >
                        {showFiles.Certificate?.map((n, i) => {
                          return (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                alignItems: "cemter",
                                gap: "5px",
                                marginBottom: "4px",
                              }}
                            >
                              <Button
                                type="primary"
                                shape="circle"
                                size="small"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: "#c95559",
                                  borderColor: "#c95559",
                                  // borderRadius: "6px",
                                }}
                                disabled={
                                  permissionData.isAuthenticated &&
                                  !permissionData.isSeller
                                }
                                onClick={() =>
                                  deleteFileUpload("Certificate", n.name)
                                }
                              >
                                <CloseOutlined
                                  style={{
                                    color: "#ffff",
                                  }}
                                  rev={undefined}
                                />
                              </Button>
                              <div key={i} className="list-file">
                                {i + 1}. {n.name}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      {errosSize.Certificate.length > 0 &&
                        errosSize.Certificate.map((err, i) => {
                          return (
                            <p key={i} className="error-message">
                              {err.message}
                            </p>
                          );
                        })}
                    </span>
                    <div style={{ position: "relative" }}>
                      <input
                        type="file"
                        multiple
                        onChange={(e) => onChangeFile(e, "Certificate")}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                      <Button
                        onClick={() => uploadFileHandler("Certificate")}
                        style={{
                          position: "absolute",
                          right: 0,
                          backgroundColor: "#6598F6",
                          color: "white",
                          borderRadius: "6px",
                        }}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      >
                        Upload File
                      </Button>
                      <br />
                      <p
                        style={{
                          fontSize: "0.9rem",
                          marginBottom: 0,
                          marginTop: 10,
                        }}
                      >
                        เอกสารต้องแนบเป็นไฟล์ pdf (ขนาดไม่เกิน 2 MB)
                      </p>
                    </div>
                  </div>
                  <label htmlFor="" className="label">
                    แบบหนังสือรับรองผลงาน
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "400px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <div
                        style={{
                          minHeight: "90px",
                          border: "1px solid black",
                          borderRadius: "6px",
                          borderColor: "#C5C5C5",
                          padding: "10px",
                        }}
                      >
                        {showFiles.CertOfCompletion?.map((n, i) => {
                          return (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                alignItems: "cemter",
                                gap: "5px",
                                marginBottom: "4px",
                              }}
                            >
                              <Button
                                type="primary"
                                shape="circle"
                                size="small"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: "#c95559",
                                  borderColor: "#c95559",
                                  // borderRadius: "6px",
                                }}
                                onClick={() =>
                                  deleteFileUpload("CertOfCompletion", n.name)
                                }
                              >
                                <CloseOutlined
                                  style={{
                                    color: "#ffff",
                                  }}
                                  rev={undefined}
                                />
                              </Button>
                              <div key={i} className="list-file">
                                {i + 1}. {n.name}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      {errosSize.CertOfCompletion.length > 0 &&
                        errosSize.CertOfCompletion.map((err, i) => {
                          return (
                            <p key={i} className="error-message">
                              {err.message}
                            </p>
                          );
                        })}
                    </span>
                    <div style={{ position: "relative" }}>
                      <input
                        type="file"
                        multiple
                        onChange={(e) => onChangeFile(e, "CertOfCompletion")}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                      <Button
                        onClick={() => uploadFileHandler("CertOfCompletion")}
                        style={{
                          position: "absolute",
                          right: 0,
                          backgroundColor: "#6598F6",
                          color: "white",
                          borderRadius: "6px",
                        }}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      >
                        Upload File
                      </Button>
                      <br />
                      <p
                        style={{
                          fontSize: "0.9rem",
                          marginBottom: 0,
                          marginTop: 10,
                        }}
                      >
                        เอกสารต้องแนบเป็นไฟล์ pdf (ขนาดไม่เกิน 2 MB)
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="content-note" style={{ backgroundColor: "#EFE2E3" }}>
            <p>
              หนังสือรับรองการจดทะเบียนนิติบุคคล&nbsp;
              <span style={{ color: "#C95559" }}>
                (เอกสารแนบต้องรับรองสำเนาถูกต้องลงลายมือชื่อและประทับตรา
                <br />
                โดยเอกสารต้องเป็นไฟล์ pdf และมีขนาดไม่เกิน 2 เมกะไบต์)
              </span>
            </p>
            <p>
              หมายเหตุ
              <br />
              1. รายการที่มี{" "}
              <span style={{ color: "#C95559" }}>ดอกจันสีแดง</span>{" "}
              หมายถึงต้องบันทึกข้อมูล <br />
              2. กรณีเป็นห้างหุ้นส่วนจำกัด ให้แนบไฟล์หนังสือรับรอง
              และรายละเอียดวัตถุประสงค์ <br />
              3. กรณีเป็นบุคคลธรรมดาที่จดทะเบียนกับกระทรวงพาณิชย์
              ให้แนบไฟล์ใบทะเบียนพาณิชย์ <br />
              4. กรณีเป็นบุคคลธรรมดาที่ไม่ได้จดทะเบียนกับกระทรวงพาณิชย์
              ให้แนบไฟล์บัตรประชาชน
            </p>
            <Link to={"#"} className="link-description">
              คลิกดูรายละเอียดหลักฐานประกอบการลงทะเบียน
            </Link>
          </div>
          <div style={{ borderRadius: "8px" }}>
            <div className="container-input" style={{ paddingBottom: "30px" }}>
              <div className="header-content">บันทึกหมวดหมู่สินค้า/บริการ</div>
              <div className="content-form">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "0.5fr 1.5fr",
                    gridTemplateRows: "auto",
                    rowGap: "8px",
                  }}
                >
                  <label htmlFor="" className="label">
                    รูปโลโก้
                  </label>
                  <div>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "100px 1fr",
                        columnGap: "20px",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          minHeight: "auto",
                          position: "relative",
                          border: "1px solid #C5C5C5",
                          borderRadius: "6px",
                        }}
                      >
                        {showFiles.LogoPath.length > 0 ? (
                          <>
                            <div
                              style={{
                                backgroundColor: "#f5222d",
                                borderRadius: "50%",
                                border: "1px solid black",
                                padding: "2px",
                                position: "absolute",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 2,
                                right: 0,
                                marginTop: "-7px",
                                marginRight: "-7px",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                deleteFileUpload(
                                  "LogoPath",
                                  showFiles.LogoPath[0].name
                                )
                              }
                            >
                              <CloseOutlined
                                style={{
                                  color: "#ffff",
                                }}
                                rev={undefined}
                              />
                            </div>
                            <img
                              src={
                                sellerDetail?.LogoPath &&
                                  sellerDetail?.LogoPath ==
                                  showFiles.LogoPath[0].name
                                  ? `${location.protocol}//${localStorage.getItem("tinyUrl")
                                    ? localStorage.getItem("tinyUrl")
                                    : ""
                                  }${watch(`LogoPath.${0}`)}`
                                  : URL.createObjectURL(
                                    showFiles?.LogoPath[0].file!
                                  )
                              }
                              alt="Uploaded File"
                              style={{
                                width: "100%",
                                height: "100%",
                                position: "absolute",
                                objectFit: "cover",
                                objectPosition: "center",
                                zIndex: 1,
                              }}
                            />
                          </>
                        ) : (
                          <input
                            type="text"
                            style={{ width: "100%", height: "100%" }}
                            disabled={
                              permissionData.isAuthenticated &&
                              !permissionData.isSeller
                            }
                          />
                        )}
                      </div>
                      <div
                        style={{
                          position: "relative",
                          minHeight: "90px",
                        }}
                      >
                        <input
                          type="file"
                          onChange={(e) => onChangeFile(e, "LogoPath")}
                          disabled={
                            permissionData.isAuthenticated &&
                            !permissionData.isSeller
                          }
                        />
                        <Button
                          onClick={() => uploadFileHandler("LogoPath")}
                          style={{
                            position: "absolute",
                            right: 0,
                            backgroundColor: "#6598F6",
                            color: "white",
                            borderRadius: "6px",
                          }}
                          disabled={
                            permissionData.isAuthenticated &&
                            !permissionData.isSeller
                          }
                        >
                          Upload Image
                        </Button>
                        <br />
                        <p style={{ fontSize: "0.9rem", margin: 0 }}>
                          ในรูปแบบ jpg, png, (ขนาดไม่เกิน 20 MB)
                        </p>
                      </div>
                    </div>
                    {errosSize.LogoPath.length > 0 &&
                      errosSize.LogoPath.map((err, i) => {
                        return (
                          <p key={i} className="error-message">
                            {err.message}
                          </p>
                        );
                      })}
                  </div>

                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    ประเภทสินค้า/บริการ
                  </label>
                  <div>
                    {serviceField.map((data, i) => {
                      return (
                        <div
                          key={data.id}
                          style={{
                            display: "flex",
                            backgroundColor: "#EEEEEE",
                            padding: "10px 20px 10px 20px",
                            justifyContent: "center",
                            columnGap: "10px",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              flexDirection: "column",
                            }}
                          >
                            <div style={{ minWidth: "310px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "flex-start",
                                  flexShrink: 1,
                                  flexGrow: 1,
                                  gap: "6px",
                                }}
                              >
                                <Controller
                                  control={control}
                                  name={`ServiceAndItem.${i}.ServiceItemType`}
                                  render={({
                                    field: { onChange, onBlur, value, ref },
                                  }) => (
                                    <Select
                                      ref={ref}
                                      onBlur={onBlur}
                                      value={value}
                                      style={{
                                        width: 100,
                                        minWidth: 100,
                                        maxWidth: 100,
                                      }}
                                      disabled={
                                        permissionData.isAuthenticated &&
                                        !permissionData.isSeller
                                      }
                                      placeholder="ระบุประเภทสินค้าบริการ"
                                      onChange={(value) => {
                                        onChange(value);
                                        setValue(
                                          `ServiceAndItem.${i}.ServiceItemName`,
                                          undefined
                                        );
                                        setValue(
                                          `ServiceAndItem.${i}.OtherService`,
                                          undefined
                                        );

                                        const currentName = watch(`ServiceAndItem.${i}.ServiceItemName`);
                                        if (value && currentName) {
                                          clearErrors("ServiceAndItem");
                                        }
                                      }}
                                      allowClear
                                      options={
                                        category?.map((category) => ({
                                          label: category,
                                          value: category,
                                        })) || []
                                      }
                                    />
                                  )}
                                />
                                <Controller
                                  control={control}
                                  name={`ServiceAndItem.${i}.ServiceItemName`}
                                  render={({
                                    field: { onChange, onBlur, value, ref },
                                  }) => (
                                    <Select
                                      ref={ref}
                                      onBlur={onBlur}
                                      value={value}
                                      style={{
                                        width: 150,
                                        minWidth: 300,
                                        maxWidth: 300,
                                      }}
                                      disabled={
                                        permissionData.isAuthenticated &&
                                        !permissionData.isSeller
                                      }
                                      allowClear
                                      placeholder="ระบุสินค้าบริการ"
                                      onChange={(value) => {
                                        console.log("value = ", value);
                                        onChange(value);

                                        // แสดง input เฉพาะตอนที่ ServiceItemType === "อื่นๆ" เท่านั้น
                                        const newShowOther = [...showOtherInput];
                                        const currentType = watch(`ServiceAndItem.${i}.ServiceItemType`);
                                        newShowOther[i] = currentType === "อื่นๆ" && value != null;
                                        setShowOtherInput(newShowOther);

                                        if (value && currentType) {
                                          clearErrors("ServiceAndItem");
                                        }
                                      }}
                                      options={itemOptions(i)}
                                    />
                                  )}
                                />
                                {
                                  // แสดง OtherService input เมื่อ ServiceItemType หรือ ServiceItemName เป็น "อื่นๆ" หรือ "โปรดระบุ"
                                  watch(`ServiceAndItem.${i}.ServiceItemType`) != "อื่นๆ" && watch(`ServiceAndItem.${i}.ServiceItemName`) != "อื่นๆ" && watch(`ServiceAndItem.${i}.ServiceItemName`) != "โปรดระบุ" ?
                                    (
                                      <div
                                        style={{
                                          backgroundColor: "#C5C5C5",
                                          padding: "2px 10px 2px 10px",
                                          borderRadius: "6px",
                                          fontSize: "0.9rem",
                                          color: "black",
                                          minWidth: 250,
                                        }}
                                      >
                                        โปรดระบุ เช่น เครื่องอุปโภค/บริโภค
                                      </div>
                                    ) : (
                                      <input
                                        {...register(
                                          `ServiceAndItem.${i}.OtherService`,
                                          {
                                            validate: (value) =>
                                              !!value?.trim() || "กรุณาระบุบริการอื่นๆ",
                                          }
                                        )}
                                        disabled={
                                          permissionData.isAuthenticated &&
                                          !permissionData.isSeller
                                        }
                                        style={{ minWidth: 250 }}
                                        placeholder="ระบุบริการอื่นๆ"
                                        type="text"
                                      />
                                    )}
                              </div>
                              {(errors?.ServiceAndItem?.[i] as any)?.OtherService && (
                                <p className="error-message">
                                  {(errors.ServiceAndItem![i] as any)?.OtherService?.message}
                                </p>
                              )}
                            </div>
                          </div>
                          {i === 0 && serviceField.length < 3 && (
                            <Button
                              type="primary"
                              shape="default"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "#6598F6",
                                borderColor: "#6598F6",
                                borderRadius: "6px",
                              }}
                              disabled={
                                permissionData.isAuthenticated &&
                                !permissionData.isSeller
                              }
                              onClick={() => {
                                let newService: ServiceAndItem = {
                                  ServiceItemType: undefined,
                                  ServiceItemName: undefined,
                                  OtherService: undefined
                                };
                                appenService(newService);
                              }}
                            >
                              <PlusCircleOutlined rev={undefined} />
                            </Button>
                          )}

                          {serviceField.length > 1 &&
                            (i !== 0 || serviceField.length === 3) && (
                              <Button
                                type="primary"
                                shape="default"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: "#c95559",
                                  borderColor: "#c95559",
                                  borderRadius: "6px",
                                }}
                                disabled={
                                  permissionData.isAuthenticated &&
                                  !permissionData.isSeller
                                }
                                onClick={() => {
                                  removeService(i);
                                }}
                              >
                                <DeleteOutlined rev={undefined} />
                              </Button>
                            )}
                        </div>
                      );
                    })}

                    {errors.ServiceAndItem?.[0] &&
                      //showFiles.CertificateOfRegisteration.length === 0 && (
                      <p className="error-message">
                        {(errors.ServiceAndItem?.[0] as any)?.message}
                      </p>
                      //)
                    }
                  </div>

                  <label htmlFor="" className="label">
                    แนบไฟล์ Catalog
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "400px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <div
                        style={{
                          minHeight: "90px",
                          border: "1px solid black",
                          borderRadius: "6px",
                          borderColor: "#C5C5C5",
                          padding: "10px",
                        }}
                      >
                        {showFiles.CatalogFilePath?.map((n, i) => {
                          return (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                alignItems: "cemter",
                                gap: "5px",
                                marginBottom: "4px",
                              }}
                            >
                              <Button
                                type="primary"
                                shape="circle"
                                size="small"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: "#c95559",
                                  borderColor: "#c95559",
                                }}
                                disabled={
                                  permissionData.isAuthenticated &&
                                  !permissionData.isSeller
                                }
                                onClick={() =>
                                  deleteFileUpload("CatalogFilePath", n.name)
                                }
                              >
                                <CloseOutlined
                                  style={{
                                    color: "#ffff",
                                  }}
                                  rev={undefined}
                                />
                              </Button>
                              <div key={i} className="list-file">
                                {i + 1}. {n.name}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      {errosSize.CatalogFilePath.length > 0 &&
                        errosSize.CatalogFilePath.map((err, i) => {
                          return (
                            <p key={i} className="error-message">
                              {err.message}
                            </p>
                          );
                        })}
                    </span>
                    <div style={{ position: "relative" }}>
                      <input
                        multiple
                        type="file"
                        onChange={(e) => onChangeFile(e, "CatalogFilePath")}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                      <Button
                        onClick={() => uploadFileHandler("CatalogFilePath")}
                        style={{
                          position: "absolute",
                          right: 0,
                          backgroundColor: "#6598F6",
                          color: "white",
                          borderRadius: "6px",
                        }}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      >
                        Upload File
                      </Button>
                      <br />
                      <p style={{ fontSize: "0.9rem", margin: 0 }}>
                        ในรูปแบบ pdf (ขนาดไม่เกิน 20 MB)
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {permissionData?.isAuthenticated && (
            <div className="container-input" style={{ paddingBottom: "30px" }}>
              <div className="header-content">สถานะผู้ค้า</div>
              <div
                className="content-form"
                style={{ display: "flex", flexDirection: "column", gap: 10 }}
              >
                <Row align="middle">
                  <Col span={5}>
                    <label htmlFor="" className="label">
                      สถานะผู้ค้า
                    </label>
                  </Col>
                  <Col span={8}>
                    <Controller
                      control={control}
                      name="SellerStatus"
                      render={({ field }) => (
                        <Select
                          {...field}
                          disabled={
                            permissionData?.isAuthenticated &&
                              permissionData?.isSeller
                              ? true
                              : permissionData?.isAuthenticated &&
                                permissionData?.isAdmin
                                ? false
                                : true
                          }
                          placeholder="เลือกสถานะ"
                          options={[
                            { label: "Pending", value: "Pending" },
                            { label: "AVL-A", value: "AVL-A" },
                            { label: "AVL-B", value: "AVL-B" },
                            { label: "AVL-C", value: "AVL-C" },
                            { label: "Blacklist", value: "BlackList" },
                          ]}
                        />
                      )}
                    />
                  </Col>
                </Row>
                <Row align="middle">
                  <Col span={5}>
                    <label htmlFor="" className="label">
                      กำหนดวันส่งสินค้า:
                    </label>
                  </Col>
                  <Col span={19}>
                    <Row gutter={[10, 10]}>
                      <Col span={24}>
                        <Row gutter={5} align="middle" justify="start">
                          <Col span={5}>
                            {permissionData?.isAuthenticated &&
                              permissionData?.isSeller
                              ? false
                              : permissionData?.isAuthenticated &&
                                permissionData?.isAdmin &&
                                watch("SellerStatus") === "AVL-C"
                                ? true
                                : false && (
                                  <span style={{ color: "red" }}>*&nbsp;</span>
                                )}
                            <label htmlFor="">กรุงเทพและปริมณฑล</label>
                          </Col>
                          <Col span={5}>
                            <input
                              type="number"
                              {...register("deliveryDate.capital", {
                                required: {
                                  value:
                                    permissionData?.isAuthenticated &&
                                      permissionData?.isSeller
                                      ? false
                                      : permissionData?.isAuthenticated &&
                                        permissionData?.isAdmin &&
                                        watch("SellerStatus") === "AVL-C"
                                        ? true
                                        : false,
                                  message: "กรุณากรอกกรุงเทพและปริมณฑล",
                                },
                                min: {
                                  value:
                                    permissionData?.isAuthenticated &&
                                      permissionData?.isAdmin &&
                                      watch("SellerStatus") === "AVL-C"
                                      ? 1
                                      : "",
                                  message: "กรุงเทพและปริมณฑลต้องมากกว่า 0",
                                },
                              })}
                              disabled={
                                permissionData?.isAuthenticated &&
                                  permissionData?.isSeller
                                  ? true
                                  : permissionData?.isAuthenticated &&
                                    permissionData?.isAdmin &&
                                    watch("SellerStatus") === "AVL-C"
                                    ? false
                                    : true
                              }
                            />
                            {errors.deliveryDate?.capital && (
                              <p className="error-message">
                                {errors.deliveryDate.capital.message}
                              </p>
                            )}
                          </Col>
                          <Col span={2}>วันที่ทำการ</Col>
                        </Row>
                      </Col>
                      <Col span={24}>
                        <Row gutter={5} align="middle" justify="start">
                          <Col span={5}>
                            {permissionData?.isAuthenticated &&
                              permissionData?.isSeller
                              ? false
                              : permissionData?.isAuthenticated &&
                                permissionData?.isAdmin &&
                                watch("SellerStatus") === "AVL-C"
                                ? true
                                : false && (
                                  <span style={{ color: "red" }}>*&nbsp;</span>
                                )}
                            <label htmlFor="">ต่างจังหวัด</label>
                          </Col>
                          <Col span={5}>
                            <input
                              type="number"
                              {...register("deliveryDate.provincial", {
                                required: {
                                  value:
                                    permissionData?.isAuthenticated &&
                                      permissionData?.isSeller
                                      ? false
                                      : permissionData?.isAuthenticated &&
                                        permissionData?.isAdmin &&
                                        watch("SellerStatus") === "AVL-C"
                                        ? true
                                        : false,
                                  message: "กรุณากรอกต่างจังหวัด",
                                },
                                min: {
                                  value:
                                    permissionData?.isAuthenticated &&
                                      permissionData?.isAdmin &&
                                      watch("SellerStatus") === "AVL-C"
                                      ? 1
                                      : "",
                                  message: "ต่างจังหวัดต้องมากกว่า 0",
                                },
                              })}
                              disabled={
                                permissionData?.isAuthenticated &&
                                  permissionData?.isSeller
                                  ? true
                                  : permissionData?.isAuthenticated &&
                                    permissionData?.isAdmin &&
                                    watch("SellerStatus") === "AVL-C"
                                    ? false
                                    : true
                              }
                            />
                            {errors.deliveryDate?.provincial && (
                              <p className="error-message">
                                {errors.deliveryDate.provincial.message}
                              </p>
                            )}
                          </Col>
                          <Col span={2}>วันที่ทำการ</Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </div>
          )}

          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              columnGap: "10px",
            }}
          >
            <Button
              style={{
                height: "60px",
                color: "white",
                width: "200px",
                fontSize: "30px",
                fontWeight: "bold",
                backgroundColor: "#6598F6",
                borderRadius: "6px",
                marginBottom: "80px",
              }}
              onClick={openConfirmDailog}
            >
              บันทึกข้อมูล
            </Button>
            <Button
              style={{
                height: "60px",
                color: "white",
                width: "200px",
                fontSize: "30px",
                fontWeight: "bold",
                borderRadius: "6px",
                backgroundColor: "#C95559",
              }}
              onClick={() => {
                permissionData?.isAuthenticated && permissionData?.isSeller
                  ? history.go(0)
                  : permissionData?.isAuthenticated && permissionData.isAdmin
                    ? history.push("/Supplierlist")
                    : history.push("/");
              }}
            >
              ปิด
            </Button>
          </div>
        </div>
      </form>
      <ConfirmModal
        visible={showDailogConfirm}
        onCancel={cancelDailog}
        onOk={onOk}
      />
      {dailogContinue}
      <OTPModal
        visible={showModalOtp}
        onOk={onOkOTP}
        onClose={onCloseOTP}
        confirmOTP={confirmOTP}
      />
    </>
  );
};

export default RegisterLegalEntityScreen;
